/* eslint-disable */
/* This is autogenerated file, DO NOT add anything manually. Run "yarn generate" to generate types. */
export type Maybe<T> = T | null

export interface ValidateDeliveryAddressInput {
    line1: string

    line2?: Maybe<string>

    state: string

    city: string

    zip: string

    firstName: string

    lastName: string

    email: string

    phoneNumber: string

    scheduledForDateTime?: Maybe<string>

    note?: Maybe<string>
}

export interface GetPaymentAuthTokenInput {
    amount?: Maybe<number>

    gateway: PaymentGateway

    type?: Maybe<GetPaymentTokenType>

    captchaToken?: Maybe<string>
}

export interface GetPaymentRedirectUrlInput {
    amount?: Maybe<number>

    gateway: PaymentGateway

    customer: GetPaymentRedirectUrlCustomer

    products: GetPaymentRedirectUrlProduct[]

    callbackUrl: string
}

export interface GetPaymentRedirectUrlCustomer {
    email: string
}

export interface GetPaymentRedirectUrlProduct {
    name: string

    price: number

    quantity: number
}

export interface CalculateDeliveryFeeInput {
    lat: number

    lng: number

    zip: string

    total: number
}

export interface OrderInput2 {
    orderId: string

    customer?: Maybe<CustomerInput>

    note?: Maybe<string>

    scheduledForDateTime?: Maybe<string>

    assignmentId?: Maybe<string>

    assignment?: Maybe<string>

    tableName?: Maybe<string>

    promoCodeId?: Maybe<string>

    cardProgramCardKey?: Maybe<string>

    items: OrderItemInput[]

    addresses?: Maybe<OrderAddressInput[]>

    cardInfo?: Maybe<CardInfo>

    useLoyaltyPoints?: Maybe<boolean>

    deliveryFee?: Maybe<number>

    tipAmount?: Maybe<number>

    isEcoFriendly?: Maybe<boolean>

    expectedPaymentType?: Maybe<ExpectedPaymentType>

    skipPaymentProcessing?: Maybe<boolean>

    isDigitalOrder?: Maybe<boolean>
}

export interface CustomerInput {
    firstName?: Maybe<string>

    lastName?: Maybe<string>

    email: string

    phoneNumber?: Maybe<string>
}

export interface OrderItemInput {
    id?: Maybe<string>

    productId: string

    groupId?: Maybe<string>

    note?: Maybe<string>

    customPrice?: Maybe<number>

    quantity?: Maybe<number>

    cateringType?: Maybe<ProductCateringType>

    unit?: Maybe<ProductUnitType>

    unitQuantity?: Maybe<number>

    children?: Maybe<OrderItemInput[]>

    pricings?: Maybe<string[]>

    parentModifierId?: Maybe<string>

    parentModifierGroupId?: Maybe<string>
}

export interface OrderAddressInput {
    addressId?: Maybe<string>

    type?: Maybe<OrderAddressInputType>

    firstName?: Maybe<string>

    middleName?: Maybe<string>

    surname?: Maybe<string>

    email?: Maybe<string>

    phone?: Maybe<string>

    line1?: Maybe<string>

    line2?: Maybe<string>

    state?: Maybe<string>

    city?: Maybe<string>

    zip?: Maybe<string>

    note?: Maybe<string>

    saveIt?: Maybe<boolean>

    addressDistance?: Maybe<number>

    isGift?: Maybe<boolean>
}

export interface CardInfo {
    paymentCardId?: Maybe<string>

    token?: Maybe<string>

    tokenGateway: PaymentGateway

    saveIt?: Maybe<boolean>

    expiration?: Maybe<string>

    cvv?: Maybe<string>

    zip?: Maybe<string>

    issuer?: Maybe<CardIssuer>

    last4?: Maybe<string>
}

export interface PaymentInput {
    paymentId?: Maybe<string>

    orderId: string

    gatewayTransactionId?: Maybe<string>

    cardInfo?: Maybe<CardInfo>

    useLoyaltyPoints?: Maybe<boolean>

    loyaltyPoints?: Maybe<number>

    giftCardKey?: Maybe<string>

    giftCardAmount?: Maybe<number>

    tipAmount?: Maybe<number>

    orderItems?: Maybe<PaymentOrderItemInput[]>
}

export interface PaymentOrderItemInput {
    id: string

    quantity: number
}

export interface ChangePaymentTypeInput {
    orderId: string

    paymentMethod: string
}

export interface MibUserInput {
    name?: Maybe<string>

    phone?: Maybe<string>
}

export interface CreateMibUserAddressInput {
    line1?: Maybe<string>

    line2?: Maybe<string>

    state?: Maybe<string>

    city?: Maybe<string>

    zip?: Maybe<string>

    note?: Maybe<string>
}

export interface UpdateMibUserAddressInput {
    id: string

    line1?: Maybe<string>

    line2?: Maybe<string>

    state?: Maybe<string>

    city?: Maybe<string>

    zip?: Maybe<string>

    note?: Maybe<string>
}

export interface CreateMibUserPaymentCardInput {
    token: string

    expiration: string

    zip?: Maybe<string>

    tokenGateway: PaymentGateway

    issuer?: Maybe<CardIssuer>
}

export interface ProductSiteSignUpFormPayload {
    name?: Maybe<string>

    emailAddress?: Maybe<string>

    phoneNumber?: Maybe<string>

    companyName?: Maybe<string>

    companyAddress?: Maybe<string>
}

export interface AttentionRequestedInput {
    tableId: string

    reason?: Maybe<AttentionReasonEnum>
}

export interface NumberInput {
    number: string

    nextCounter: number

    terminalId: string
}

export interface TipPaymentInput {
    orderId: string

    amountTip: number

    transactionNumber?: Maybe<NumberInput>
}

export enum MibLocationType {
    Standard = "Standard",
    SingleProduct = "SingleProduct",
}

export enum MainMenuIcon {
    Menu = "Menu",
    Events = "Events",
    Products = "Products",
    Tickets = "Tickets",
    Services = "Services",
    Services2 = "Services2",
    Services3 = "Services3",
    Menu2 = "Menu2",
    Menu3 = "Menu3",
    Drinks = "Drinks",
    Drinks2 = "Drinks2",
}

export enum DeliveryAreaRestriction {
    Disabled = "disabled",
    Distance = "distance",
    ZipCodes = "zipCodes",
    Areas = "areas",
}

export enum DoorDashDelivery {
    Enabled = "ENABLED",
    Disabled = "DISABLED",
    OnDemand = "ON_DEMAND",
}

export enum TippingMethodEnum {
    Simple = "simple",
    Smart = "smart",
}

export enum MibLayoutTemplateType {
    Standard = "standard",
    Simple = "simple",
}

export enum PaymentGateway {
    Converge = "Converge",
    CardPointe = "CardPointe",
    Tsys = "TSYS",
    PayU = "PayU",
}

export enum Currency {
    Usd = "USD",
    Czk = "CZK",
}

export enum ProductCateringType {
    Serving = "serving",
    Person = "person",
    Tray = "tray",
    Platter = "platter",
    Dozen = "dozen",
    HalfTray = "halfTray",
    Package = "package",
    Pan = "pan",
    Batch = "batch",
}

export enum ProductUnitType {
    Minute = "minute",
    Hour = "hour",
    Day = "day",
    Gram = "gram",
    Kilogram = "kilogram",
    Ton = "ton",
    Pound = "pound",
    Milliliter = "milliliter",
    Liter = "liter",
    Ounce = "ounce",
    FluidOunce = "fluidOunce",
    Cup = "cup",
    Pint = "pint",
    Quart = "quart",
    Gallon = "gallon",
    Centimeter = "centimeter",
    Meter = "meter",
    Kilometer = "kilometer",
    Inch = "inch",
    Feet = "feet",
    Yard = "yard",
    SquareCentimeter = "squareCentimeter",
    SquareMeter = "squareMeter",
    SquareKilometer = "squareKilometer",
    SquareInch = "squareInch",
    SquareFeet = "squareFeet",
}

export enum OrderState {
    New = "new",
    Created = "created",
    Declined = "declined",
    Active = "active",
    Ready = "ready",
    Closed = "closed",
    Deleted = "deleted",
}

export enum OrderPaymentMethod {
    Pos = "pos",
    Online = "online",
}

export enum OrderFulfillmentType {
    Delivery = "delivery",
    Pickup = "pickup",
    Forhere = "forhere",
}

export enum ModifierGroupType {
    Option = "option",
    Modifier = "modifier",
}

export enum OrderPaymentType {
    Card = "card",
    Cash = "cash",
    External = "external",
}

export enum OrderPaymentState {
    Pending = "pending",
    Processed = "processed",
    Voided = "voided",
}

export enum OrderPriceComponentType {
    CardFee = "cardFee",
    CashDiscount = "cashDiscount",
    Gratuity = "gratuity",
    ServiceFee = "serviceFee",
}

export enum GetPaymentTokenType {
    Sale = "Sale",
    ApplePay = "ApplePay",
}

export enum CalculateDeliveryFeeError {
    NotWithinArea = "NOT_WITHIN_AREA",
    Error = "ERROR",
}

export enum OrderAddressInputType {
    Delivery = "Delivery",
    Billing = "Billing",
}

export enum CardIssuer {
    Visa = "Visa",
    Discover = "Discover",
    MasterCard = "MasterCard",
    Amex = "Amex",
    Diners = "Diners",
    Jcb = "JCB",
    Maestro = "Maestro",
    UnionPay = "UnionPay",
}

export enum ExpectedPaymentType {
    Cash = "cash",
    Card = "card",
}

export enum AttentionReasonEnum {
    Check = "check",
}

export enum BusinessErrorType {
    LowStock = "LowStock",
    NotAvailable = "NotAvailable",
    BusinessClosed = "BusinessClosed",
}

export enum LowQuantityItemType {
    Product = "product",
    Option = "option",
    Modifier = "modifier",
}

export enum ResponseErrorType {
    BusinessError = "BUSINESS_ERROR",
    UserNotFound = "USER_NOT_FOUND",
    UserNotAuthenticated = "USER_NOT_AUTHENTICATED",
    BadRequest = "BAD_REQUEST",
    InvalidAuth = "INVALID_AUTH",
    NotFound = "NOT_FOUND",
    LocationNotFound = "LOCATION_NOT_FOUND",
    AccountNotFound = "ACCOUNT_NOT_FOUND",
    ServiceNotActive = "SERVICE_NOT_ACTIVE",
    NoLocationPickerServices = "NO_LOCATION_PICKER_SERVICES",
}

// ====================================================
// Documents
// ====================================================

export type CategoriesQueryVariables = {}

export type CategoriesQueryQuery = {
    __typename?: "Query"

    productsCategories: Maybe<(Maybe<CategoriesQueryProductsCategories>)[]>
}

export type CategoriesQueryProductsCategories = {
    __typename?: "ProductCategory"

    id: Maybe<string>

    name: Maybe<string>

    availability: Maybe<CategoriesQueryAvailability>

    products: Maybe<(Maybe<CategoriesQueryProducts>)[]>
}

export type CategoriesQueryAvailability = {
    __typename?: "CategoryAvailabilityData"

    timeDataRaw: CategoriesQueryTimeDataRaw

    timeData: CategoriesQueryTimeData[]
}

export type CategoriesQueryTimeDataRaw = {
    __typename?: "TimeEntry"

    id: string

    name: string

    timeSpans: Maybe<CategoriesQueryTimeSpans[]>
}

export type CategoriesQueryTimeSpans = {
    __typename?: "TimeSpan"

    start: string

    duration: number

    isExclusion: boolean
}

export type CategoriesQueryTimeData = {
    __typename?: "AvailabilityDay"

    isToday: boolean

    label: string

    hours: CategoriesQueryHours[]
}

export type CategoriesQueryHours = {
    __typename?: "AvailabilityDayHours"

    from: string

    to: string
}

export type CategoriesQueryProducts = {
    __typename?: "Product"

    id: Maybe<string>

    productId: Maybe<string>

    name: Maybe<string>

    price: Maybe<number>

    description: Maybe<string>

    isNoteEnabled: Maybe<boolean>

    minQuantity: Maybe<number>

    maxQuantity: Maybe<number>

    cateringType: Maybe<ProductCateringType>

    unit: Maybe<ProductUnitType>

    containsAlcohol: Maybe<boolean>

    images: Maybe<(Maybe<CategoriesQueryImages>)[]>

    modifierGroups: Maybe<(Maybe<CategoriesQueryModifierGroups>)[]>

    taxes: Maybe<(Maybe<CategoriesQueryTaxes>)[]>

    pricings: Maybe<(Maybe<CategoriesQueryPricings>)[]>

    availability: Maybe<CategoriesQuery___Availability>
}

export type CategoriesQueryImages = {
    __typename?: "ProductImage"

    path: string
}

export type CategoriesQueryModifierGroups = {
    __typename?: "ProductModifierGroup"

    categoryGroupId: Maybe<string>

    name: Maybe<string>

    price: Maybe<number>

    min: Maybe<number>

    max: Maybe<number>

    free: Maybe<number>

    type: Maybe<string>

    sortIndex: Maybe<number>

    isExclusion: Maybe<boolean>

    displayType: Maybe<string>

    groupPrice: Maybe<number>

    options: Maybe<(Maybe<CategoriesQueryOptions>)[]>
}

export type CategoriesQueryOptions = {
    __typename?: "ProductModifier"

    categoryGroupItemId: Maybe<string>

    categoryGroupItemDetailId: Maybe<string>

    productId: Maybe<string>

    name: Maybe<string>

    price: Maybe<number>

    supplement: Maybe<number>

    sortIndex: Maybe<number>

    isPreset: Maybe<boolean>

    isMultipleAllowed: Maybe<boolean>

    nestedGroup: Maybe<CategoriesQueryNestedGroup>

    availability: Maybe<CategoriesQuery__Availability>
}

export type CategoriesQueryNestedGroup = {
    __typename?: "ProductModifierGroup"

    categoryGroupId: Maybe<string>

    name: Maybe<string>

    price: Maybe<number>

    min: Maybe<number>

    max: Maybe<number>

    free: Maybe<number>

    type: Maybe<string>

    sortIndex: Maybe<number>

    isExclusion: Maybe<boolean>

    displayType: Maybe<string>

    groupPrice: Maybe<number>

    options: Maybe<(Maybe<CategoriesQuery_Options>)[]>
}

export type CategoriesQuery_Options = {
    __typename?: "ProductModifier"

    categoryGroupItemId: Maybe<string>

    categoryGroupItemDetailId: Maybe<string>

    productId: Maybe<string>

    name: Maybe<string>

    price: Maybe<number>

    supplement: Maybe<number>

    sortIndex: Maybe<number>

    isPreset: Maybe<boolean>

    isMultipleAllowed: Maybe<boolean>

    availability: Maybe<CategoriesQuery_Availability>
}

export type CategoriesQuery_Availability = {
    __typename?: "ProductAvailabilityData"

    inventory: Maybe<CategoriesQueryInventory>
}

export type CategoriesQueryInventory = {
    __typename?: "InventoryAvailabilityData"

    quantity: Maybe<number>

    threshold: Maybe<number>
}

export type CategoriesQuery__Availability = {
    __typename?: "ProductAvailabilityData"

    inventory: Maybe<CategoriesQuery_Inventory>
}

export type CategoriesQuery_Inventory = {
    __typename?: "InventoryAvailabilityData"

    quantity: Maybe<number>

    threshold: Maybe<number>
}

export type CategoriesQueryTaxes = {
    __typename?: "ProductTax"

    taxId: Maybe<string>

    name: Maybe<string>

    absolute: Maybe<number>

    percentage: Maybe<number>

    isEmbedded: Maybe<boolean>
}

export type CategoriesQueryPricings = {
    __typename?: "ProductPricing"

    id: string

    name: string

    absolute: Maybe<number>

    percentage: Maybe<number>
}

export type CategoriesQuery___Availability = {
    __typename?: "ProductAvailabilityData"

    inventory: Maybe<CategoriesQuery__Inventory>
}

export type CategoriesQuery__Inventory = {
    __typename?: "InventoryAvailabilityData"

    quantity: Maybe<number>

    threshold: Maybe<number>
}

export type CategoriesQuery2Variables = {}

export type CategoriesQuery2Query = {
    __typename?: "Query"

    productsCategories2: Maybe<CategoriesQuery2ProductsCategories2>
}

export type CategoriesQuery2ProductsCategories2 = {
    __typename?: "ProductCategories"

    id: Maybe<string>

    productCategories: Maybe<(Maybe<CategoriesQuery2ProductCategories>)[]>

    modifierGroups: Maybe<(Maybe<CategoriesQuery2_ModifierGroups>)[]>
}

export type CategoriesQuery2ProductCategories = {
    __typename?: "ProductCategory"

    id: Maybe<string>

    name: Maybe<string>

    availability: Maybe<CategoriesQuery2Availability>

    products: Maybe<(Maybe<CategoriesQuery2Products>)[]>
}

export type CategoriesQuery2Availability = {
    __typename?: "CategoryAvailabilityData"

    timeDataRaw: CategoriesQuery2TimeDataRaw

    timeData: CategoriesQuery2TimeData[]
}

export type CategoriesQuery2TimeDataRaw = {
    __typename?: "TimeEntry"

    id: string

    name: string

    timeSpans: Maybe<CategoriesQuery2TimeSpans[]>
}

export type CategoriesQuery2TimeSpans = {
    __typename?: "TimeSpan"

    start: string

    duration: number

    isExclusion: boolean
}

export type CategoriesQuery2TimeData = {
    __typename?: "AvailabilityDay"

    isToday: boolean

    label: string

    hours: CategoriesQuery2Hours[]
}

export type CategoriesQuery2Hours = {
    __typename?: "AvailabilityDayHours"

    from: string

    to: string
}

export type CategoriesQuery2Products = {
    __typename?: "Product"

    id: Maybe<string>

    productId: Maybe<string>

    name: Maybe<string>

    price: Maybe<number>

    description: Maybe<string>

    isNoteEnabled: Maybe<boolean>

    minQuantity: Maybe<number>

    maxQuantity: Maybe<number>

    cateringType: Maybe<ProductCateringType>

    unit: Maybe<ProductUnitType>

    containsAlcohol: Maybe<boolean>

    images: Maybe<(Maybe<CategoriesQuery2Images>)[]>

    modifierGroups: Maybe<(Maybe<CategoriesQuery2ModifierGroups>)[]>

    taxes: Maybe<(Maybe<CategoriesQuery2Taxes>)[]>

    pricings: Maybe<(Maybe<CategoriesQuery2Pricings>)[]>

    availability: Maybe<CategoriesQuery2_Availability>
}

export type CategoriesQuery2Images = {
    __typename?: "ProductImage"

    path: string
}

export type CategoriesQuery2ModifierGroups = {
    __typename?: "ProductModifierGroup"

    categoryGroupUniqueId: Maybe<string>
}

export type CategoriesQuery2Taxes = {
    __typename?: "ProductTax"

    taxId: Maybe<string>

    name: Maybe<string>

    absolute: Maybe<number>

    percentage: Maybe<number>

    isEmbedded: Maybe<boolean>
}

export type CategoriesQuery2Pricings = {
    __typename?: "ProductPricing"

    id: string

    name: string

    absolute: Maybe<number>

    percentage: Maybe<number>
}

export type CategoriesQuery2_Availability = {
    __typename?: "ProductAvailabilityData"

    inventory: Maybe<CategoriesQuery2Inventory>
}

export type CategoriesQuery2Inventory = {
    __typename?: "InventoryAvailabilityData"

    quantity: Maybe<number>

    threshold: Maybe<number>
}

export type CategoriesQuery2_ModifierGroups = {
    __typename?: "ProductModifierGroup"

    categoryGroupId: Maybe<string>

    categoryGroupUniqueId: Maybe<string>

    name: Maybe<string>

    price: Maybe<number>

    min: Maybe<number>

    max: Maybe<number>

    free: Maybe<number>

    type: Maybe<string>

    sortIndex: Maybe<number>

    isExclusion: Maybe<boolean>

    displayType: Maybe<string>

    groupPrice: Maybe<number>

    options: Maybe<(Maybe<CategoriesQuery2Options>)[]>
}

export type CategoriesQuery2Options = {
    __typename?: "ProductModifier"

    categoryGroupItemId: Maybe<string>

    categoryGroupItemDetailId: Maybe<string>

    productId: Maybe<string>

    name: Maybe<string>

    price: Maybe<number>

    supplement: Maybe<number>

    sortIndex: Maybe<number>

    isPreset: Maybe<boolean>

    isMultipleAllowed: Maybe<boolean>

    nestedGroup: Maybe<CategoriesQuery2NestedGroup>

    availability: Maybe<CategoriesQuery2___Availability>
}

export type CategoriesQuery2NestedGroup = {
    __typename?: "ProductModifierGroup"

    categoryGroupId: Maybe<string>

    name: Maybe<string>

    price: Maybe<number>

    min: Maybe<number>

    max: Maybe<number>

    free: Maybe<number>

    type: Maybe<string>

    sortIndex: Maybe<number>

    isExclusion: Maybe<boolean>

    displayType: Maybe<string>

    groupPrice: Maybe<number>

    options: Maybe<(Maybe<CategoriesQuery2_Options>)[]>
}

export type CategoriesQuery2_Options = {
    __typename?: "ProductModifier"

    categoryGroupItemId: Maybe<string>

    categoryGroupItemDetailId: Maybe<string>

    productId: Maybe<string>

    name: Maybe<string>

    price: Maybe<number>

    supplement: Maybe<number>

    sortIndex: Maybe<number>

    isPreset: Maybe<boolean>

    isMultipleAllowed: Maybe<boolean>

    availability: Maybe<CategoriesQuery2__Availability>
}

export type CategoriesQuery2__Availability = {
    __typename?: "ProductAvailabilityData"

    inventory: Maybe<CategoriesQuery2_Inventory>
}

export type CategoriesQuery2_Inventory = {
    __typename?: "InventoryAvailabilityData"

    quantity: Maybe<number>

    threshold: Maybe<number>
}

export type CategoriesQuery2___Availability = {
    __typename?: "ProductAvailabilityData"

    inventory: Maybe<CategoriesQuery2__Inventory>
}

export type CategoriesQuery2__Inventory = {
    __typename?: "InventoryAvailabilityData"

    quantity: Maybe<number>

    threshold: Maybe<number>
}

export type CheckProductsAvailabilityQueryVariables = {}

export type CheckProductsAvailabilityQueryQuery = {
    __typename?: "Query"

    productsCategories: Maybe<(Maybe<CheckProductsAvailabilityQueryProductsCategories>)[]>
}

export type CheckProductsAvailabilityQueryProductsCategories = {
    __typename?: "ProductCategory"

    id: Maybe<string>

    name: Maybe<string>

    availability: Maybe<CheckProductsAvailabilityQueryAvailability>

    products: Maybe<(Maybe<CheckProductsAvailabilityQueryProducts>)[]>
}

export type CheckProductsAvailabilityQueryAvailability = {
    __typename?: "CategoryAvailabilityData"

    timeDataRaw: CheckProductsAvailabilityQueryTimeDataRaw

    timeData: CheckProductsAvailabilityQueryTimeData[]
}

export type CheckProductsAvailabilityQueryTimeDataRaw = {
    __typename?: "TimeEntry"

    id: string

    name: string

    timeSpans: Maybe<CheckProductsAvailabilityQueryTimeSpans[]>
}

export type CheckProductsAvailabilityQueryTimeSpans = {
    __typename?: "TimeSpan"

    start: string

    duration: number

    isExclusion: boolean
}

export type CheckProductsAvailabilityQueryTimeData = {
    __typename?: "AvailabilityDay"

    isToday: boolean

    label: string

    hours: CheckProductsAvailabilityQueryHours[]
}

export type CheckProductsAvailabilityQueryHours = {
    __typename?: "AvailabilityDayHours"

    from: string

    to: string
}

export type CheckProductsAvailabilityQueryProducts = {
    __typename?: "Product"

    id: Maybe<string>

    productId: Maybe<string>

    name: Maybe<string>

    price: Maybe<number>

    modifierGroups: Maybe<(Maybe<CheckProductsAvailabilityQueryModifierGroups>)[]>

    availability: Maybe<CheckProductsAvailabilityQuery__Availability>
}

export type CheckProductsAvailabilityQueryModifierGroups = {
    __typename?: "ProductModifierGroup"

    categoryGroupId: Maybe<string>

    name: Maybe<string>

    price: Maybe<number>

    type: Maybe<string>

    sortIndex: Maybe<number>

    options: Maybe<(Maybe<CheckProductsAvailabilityQueryOptions>)[]>
}

export type CheckProductsAvailabilityQueryOptions = {
    __typename?: "ProductModifier"

    categoryGroupItemId: Maybe<string>

    categoryGroupItemDetailId: Maybe<string>

    productId: Maybe<string>

    name: Maybe<string>

    price: Maybe<number>

    sortIndex: Maybe<number>

    availability: Maybe<CheckProductsAvailabilityQuery_Availability>
}

export type CheckProductsAvailabilityQuery_Availability = {
    __typename?: "ProductAvailabilityData"

    inventory: Maybe<CheckProductsAvailabilityQueryInventory>
}

export type CheckProductsAvailabilityQueryInventory = {
    __typename?: "InventoryAvailabilityData"

    quantity: Maybe<number>

    threshold: Maybe<number>
}

export type CheckProductsAvailabilityQuery__Availability = {
    __typename?: "ProductAvailabilityData"

    inventory: Maybe<CheckProductsAvailabilityQuery_Inventory>
}

export type CheckProductsAvailabilityQuery_Inventory = {
    __typename?: "InventoryAvailabilityData"

    quantity: Maybe<number>

    threshold: Maybe<number>
}

export type MerchantInfoQueryVariables = {}

export type MerchantInfoQueryQuery = {
    __typename?: "Query"

    merchantInfo: Maybe<MerchantInfoQueryMerchantInfo>
}

export type MerchantInfoQueryMerchantInfo = {
    __typename?: "MerchantInfo"

    name: string

    redirectUrl: Maybe<string>

    selectorUrl: Maybe<string>

    mibLocations: Maybe<MerchantInfoQueryMibLocations[]>

    hasMultipleLocations: Maybe<boolean>

    images: Maybe<(Maybe<MerchantInfoQueryImages>)[]>
}

export type MerchantInfoQueryMibLocations = {
    __typename?: "MibLocation"

    id: string

    url: Maybe<string>

    relativeUrl: Maybe<string>

    name: string

    type: Maybe<MibLocationType>

    line1: Maybe<string>

    line2: Maybe<string>

    zip: Maybe<string>

    city: Maybe<string>

    state: Maybe<string>

    phone_number: Maybe<string>

    email: Maybe<string>

    google_place_id: Maybe<string>

    address_longitude: Maybe<number>

    address_latitude: Maybe<number>

    webpage_url: Maybe<string>

    slug: Maybe<string>

    timezone: Maybe<string>

    hasOpenTableOrdering: boolean

    hooTimeSpans: string[]

    currency: Maybe<Currency>

    settings: MerchantInfoQuerySettings
}

export type MerchantInfoQuerySettings = {
    __typename?: "MibLocationSettings"

    isBasicButterPromoCodeEnabled: boolean

    useSandboxGateway: boolean

    desktopBackgroundImageUrl: Maybe<string>

    primaryColor: Maybe<string>

    mainMenuIcon: MainMenuIcon

    logoUrl: Maybe<string>

    minOrderValueForDelivery: Maybe<number>

    minOrderValueForPickUp: Maybe<number>

    lastTimeForDelivery: Maybe<number>

    lastTimeForPickUp: Maybe<number>

    pickupEnabled: boolean

    deliveryEnabled: boolean

    deliveryFee: Maybe<number>

    deliveryFeeConfig: Maybe<MerchantInfoQueryDeliveryFeeConfig>

    deliveryHooTimeSpans: Maybe<string[]>

    pickupHooTimeSpans: Maybe<string[]>

    isAcceptingTipsForDelivery: boolean

    isAcceptingTipsForPickUp: boolean

    isAcceptingCardForDelivery: boolean

    isAcceptingCardForPickUp: boolean

    isAcceptingCashForDelivery: boolean

    isAcceptingCashForPickUp: boolean

    maxDistanceForDelivery: Maybe<number>

    estimatedDeliveryTime: Maybe<number>

    estimatedPickUpTime: Maybe<number>

    acceptFutureOrdersForDelivery: boolean

    acceptFutureOrdersForPickUp: boolean

    futureOrdersDaysForDelivery: Maybe<number>

    futureOrdersDaysForPickUp: Maybe<number>

    twitterLink: Maybe<string>

    facebookLink: Maybe<string>

    instagramLink: Maybe<string>

    ePurchaseEnabled: boolean

    dineInEnabled: boolean

    doNotCollectEmails: boolean

    cardSurcharge: Maybe<MerchantInfoQueryCardSurcharge>

    cashDiscount: Maybe<MerchantInfoQueryCashDiscount>

    cardSurchargeText: string

    cashDiscountText: string

    icons: MerchantInfoQueryIcons[]

    doordashDelivery: Maybe<DoorDashDelivery>

    tippingMethod: TippingMethodEnum

    tippingMethodPercentages: Maybe<number[]>

    tippingPreselectedOptionIndex: Maybe<number>

    acceptOnlyFutureOrdersForDelivery: boolean

    acceptOnlyFutureOrdersForPickup: boolean

    deliveryAreaRestrictionType: DeliveryAreaRestriction

    deliveryAllowedAreas: Maybe<MerchantInfoQueryDeliveryAllowedAreas[]>

    deliveryAllowedZipCodes: Maybe<(Maybe<string>)[]>

    doNotMarkAsClosedIfClosed: boolean

    futureOrderingLeadTimeMinutesDelivery: number

    futureOrderingLeadTimeActiveDelivery: boolean

    futureOrderingLeadTimeMinutesPickup: number

    futureOrderingLeadTimeActivePickup: boolean

    isPickupCurbsideOptionEnabled: boolean

    isPickupCurbsideGuidanceEnabled: boolean

    isDeliveryContactFreeOptionEnabled: boolean

    bannerMessage: Maybe<string>

    layoutTemplate: MibLayoutTemplateType

    isPayingWithEgcEnabled: boolean

    isEcoFriendlyOptionEnabled: boolean

    isEcoFriendlyOptionDefaultChecked: boolean

    isDisabledConfig: Maybe<MerchantInfoQueryIsDisabledConfig>

    multipleMerchantsMode: Maybe<boolean>

    futureOrderingDateOnly: boolean

    shouldDisplayDesktopBusinessInfoBox: boolean

    paymentGateway: PaymentGateway

    tsysDeviceId: Maybe<string>

    applePayEnabled: boolean

    hasNewTableOrdering: Maybe<boolean>
}

export type MerchantInfoQueryDeliveryFeeConfig = {
    __typename?: "DeliveryFeeConfig"

    freeDelivery: Maybe<number>

    distanceFeeEnabled: Maybe<boolean>

    distanceFeeValues: Maybe<MerchantInfoQueryDistanceFeeValues[]>
}

export type MerchantInfoQueryDistanceFeeValues = {
    __typename?: "DistanceFeeItem"

    distance: number

    fee: number
}

export type MerchantInfoQueryCardSurcharge = {
    __typename?: "CardSurchargeInfo"

    percentage: number

    applyLimit: Maybe<number>
}

export type MerchantInfoQueryCashDiscount = {
    __typename?: "CashDiscountInfo"

    percentage: Maybe<number>

    absolute: Maybe<number>
}

export type MerchantInfoQueryIcons = {
    __typename?: "MakeItButterIcon"

    sizes: string

    src: string

    type: string
}

export type MerchantInfoQueryDeliveryAllowedAreas = {
    __typename?: "DeliveryMapAreaData"

    id: string

    fee: Maybe<number>

    minOrderAmount: Maybe<number>

    coords: MerchantInfoQueryCoords[]
}

export type MerchantInfoQueryCoords = {
    __typename?: "DeliveryMapAreaCoords"

    lat: number

    lng: number
}

export type MerchantInfoQueryIsDisabledConfig = {
    __typename?: "MibIsDisabledConfig"

    forPickup: boolean

    forDelivery: boolean

    until: Maybe<string>
}

export type MerchantInfoQueryImages = {
    __typename?: "Image"

    id: string

    url: string

    type: Maybe<string>
}

export type PaymentAuthTokenQueryVariables = {
    input?: Maybe<GetPaymentAuthTokenInput>
}

export type PaymentAuthTokenQueryQuery = {
    __typename?: "Query"

    getPaymentAuthToken: Maybe<PaymentAuthTokenQueryGetPaymentAuthToken>
}

export type PaymentAuthTokenQueryGetPaymentAuthToken = {
    __typename?: "GetPaymentAuthTokenResponse"

    token: Maybe<string>
}

export type PaymentStatusQueryVariables = {
    transactionId: string
    paymentRequestId?: Maybe<string>
    paymentGateway?: Maybe<PaymentGateway>
}

export type PaymentStatusQueryQuery = {
    __typename?: "Query"

    paymentStatus: Maybe<PaymentStatusQueryPaymentStatus>
}

export type PaymentStatusQueryPaymentStatus = {
    __typename?: "TransactionStatus"

    state: Maybe<string>

    rewards: Maybe<PaymentStatusQueryRewards[]>
}

export type PaymentStatusQueryRewards = {
    __typename?: "Reward"

    type: string

    amount: Maybe<number>
}

export type MibUserQueryVariables = {}

export type MibUserQueryQuery = {
    __typename?: "Query"

    mibUser: Maybe<MibUserQueryMibUser>
}

export type MibUserQueryMibUser = {
    __typename?: "MIBUser"

    id: Maybe<string>

    name: Maybe<string>

    email: Maybe<string>

    phone: Maybe<string>

    cognitoId: Maybe<string>

    facebookId: Maybe<string>

    googleId: Maybe<string>

    addresses: Maybe<(Maybe<MibUserQueryAddresses>)[]>

    loyaltyInfo: Maybe<(Maybe<MibUserQueryLoyaltyInfo>)[]>

    paymentCards: Maybe<(Maybe<MibUserQueryPaymentCards>)[]>

    activeSpecialPricings: Maybe<(Maybe<MibUserQueryActiveSpecialPricings>)[]>
}

export type MibUserQueryAddresses = {
    __typename?: "MIBUserAddress"

    id: string

    line1: Maybe<string>

    line2: Maybe<string>

    state: Maybe<string>

    city: Maybe<string>

    zip: Maybe<string>

    note: Maybe<string>

    lastUsedTimestamp: string

    sortIndex: number
}

export type MibUserQueryLoyaltyInfo = {
    __typename?: "MIBUserLoyaltyInfo"

    loyaltyProgramId: string

    rewardsBalance: number

    redemptionMinimum: number

    spendUntilNextReward: number
}

export type MibUserQueryPaymentCards = {
    __typename?: "MIBUserPaymentCard"

    id: string

    token: string

    name: Maybe<string>

    last4: Maybe<string>

    lastUsedTimestamp: string

    sortIndex: number
}

export type MibUserQueryActiveSpecialPricings = {
    __typename?: "MIBUserActiveSpecialPricing"

    id: string

    absolute: Maybe<number>

    name: string

    percentage: Maybe<number>
}

export type MibUserOrdersQueryVariables = {}

export type MibUserOrdersQueryQuery = {
    __typename?: "Query"

    mibUser: Maybe<MibUserOrdersQueryMibUser>
}

export type MibUserOrdersQueryMibUser = {
    __typename?: "MIBUser"

    id: Maybe<string>

    name: Maybe<string>

    email: Maybe<string>

    orders2: MibUserOrdersQueryOrders2[]
}

export type MibUserOrdersQueryOrders2 = {
    __typename?: "OrderPreview"

    id: string

    number: string

    state: string

    paymentMethod: string

    paymentState: string

    placedAt: string

    scheduledFor: Maybe<string>

    fulfillmentType: Maybe<string>

    note: Maybe<string>

    total: number

    items: MibUserOrdersQueryItems[]
}

export type MibUserOrdersQueryItems = {
    __typename?: "OrderItemPreview"

    id: string

    quantity: Maybe<number>

    name: Maybe<string>
}

export type PromoCodeValidationQueryVariables = {
    code: string
}

export type PromoCodeValidationQueryQuery = {
    __typename?: "Query"

    promoCodeValidation: Maybe<PromoCodeValidationQueryPromoCodeValidation>
}

export type PromoCodeValidationQueryPromoCodeValidation = {
    __typename?: "PromoCode"

    id: Maybe<string>

    name: Maybe<string>

    absolute: Maybe<number>

    percentage: Maybe<number>

    isEGiftCard: Maybe<boolean>

    eGiftCardRemaining: Maybe<number>

    conditions: Maybe<PromoCodeValidationQueryConditions>
}

export type PromoCodeValidationQueryConditions = {
    __typename?: "PromoConditions"

    minOrderTotal: Maybe<number>

    maxOrderTotal: Maybe<number>

    from: Maybe<string>

    until: Maybe<string>
}

export type OrderQueryVariables = {
    orderId?: Maybe<string>
}

export type OrderQueryQuery = {
    __typename?: "Query"

    order: Maybe<OrderQueryOrder>
}

export type OrderQueryOrder = {
    __typename?: "Order"

    id: string

    number: string

    note: Maybe<string>

    state: string

    createdTimestamp: string

    scheduledForDateTime: Maybe<string>

    assignment: Maybe<string>

    customerId: Maybe<string>

    customerName: Maybe<string>

    customerPhone: Maybe<string>

    customerEmail: Maybe<string>

    paymentState: string

    expectedPaymentType: Maybe<string>

    items: OrderQueryItems[]

    specialPricings: Maybe<OrderQuerySpecialPricings[]>

    address: Maybe<OrderQueryAddress>

    subtotal: number

    taxesTotal: number

    total: number

    transactions: Maybe<OrderQueryTransactions[]>

    loyaltyPointsAccrued: Maybe<number>

    surchargeTotal: Maybe<number>

    cashDiscountTotal: Maybe<number>

    deliveries: Maybe<OrderQueryDeliveries[]>
}

export type OrderQueryItems = {
    __typename?: "OrderItem"

    id: string

    quantity: Maybe<number>

    productId: Maybe<string>

    price: Maybe<number>

    name: Maybe<string>

    total: Maybe<number>

    unitPrice: Maybe<number>

    unitQuantity: Maybe<number>

    unit: Maybe<string>

    note: Maybe<string>

    originTimestamp: string

    pricings: Maybe<(Maybe<OrderQueryPricings>)[]>

    option: Maybe<OrderQueryOption>

    modifiers: Maybe<OrderQueryModifiers[]>
}

export type OrderQueryPricings = {
    __typename?: "OrderItemPricing"

    id: string

    name: Maybe<string>
}

export type OrderQueryOption = {
    __typename?: "OrderItemOption"

    id: string

    productId: string

    price: Maybe<number>

    name: Maybe<string>

    nestedModifiers: Maybe<OrderQueryNestedModifiers[]>
}

export type OrderQueryNestedModifiers = {
    __typename?: "OrderItemModifier"

    id: Maybe<string>

    productId: Maybe<string>

    name: Maybe<string>

    price: Maybe<number>

    total: Maybe<number>

    quantity: Maybe<number>

    free: Maybe<number>

    supplement: Maybe<number>

    min: Maybe<number>

    max: Maybe<number>

    items: Maybe<OrderQuery_Items[]>

    isExclusion: Maybe<boolean>
}

export type OrderQuery_Items = {
    __typename?: "OrderItemModifier"

    id: Maybe<string>

    productId: Maybe<string>

    name: Maybe<string>

    total: Maybe<number>

    price: Maybe<number>

    quantity: Maybe<number>

    free: Maybe<number>

    supplement: Maybe<number>

    isExclusion: Maybe<boolean>
}

export type OrderQueryModifiers = {
    __typename?: "OrderItemModifier"

    id: Maybe<string>

    productId: Maybe<string>

    name: Maybe<string>

    price: Maybe<number>

    total: Maybe<number>

    quantity: Maybe<number>

    free: Maybe<number>

    supplement: Maybe<number>

    min: Maybe<number>

    max: Maybe<number>

    items: Maybe<OrderQuery__Items[]>

    isExclusion: Maybe<boolean>
}

export type OrderQuery__Items = {
    __typename?: "OrderItemModifier"

    id: Maybe<string>

    productId: Maybe<string>

    name: Maybe<string>

    total: Maybe<number>

    price: Maybe<number>

    quantity: Maybe<number>

    free: Maybe<number>

    supplement: Maybe<number>

    isExclusion: Maybe<boolean>

    nestedModifiers: Maybe<OrderQuery_NestedModifiers[]>
}

export type OrderQuery_NestedModifiers = {
    __typename?: "OrderItemModifier"

    id: Maybe<string>

    productId: Maybe<string>

    name: Maybe<string>

    price: Maybe<number>

    total: Maybe<number>

    quantity: Maybe<number>

    free: Maybe<number>

    supplement: Maybe<number>

    min: Maybe<number>

    max: Maybe<number>

    items: Maybe<OrderQuery___Items[]>

    isExclusion: Maybe<boolean>
}

export type OrderQuery___Items = {
    __typename?: "OrderItemModifier"

    id: Maybe<string>

    productId: Maybe<string>

    name: Maybe<string>

    total: Maybe<number>

    price: Maybe<number>

    quantity: Maybe<number>

    free: Maybe<number>

    supplement: Maybe<number>

    isExclusion: Maybe<boolean>
}

export type OrderQuerySpecialPricings = {
    __typename?: "OrderSpecialPricing"

    id: string

    name: Maybe<string>

    percentage: Maybe<number>

    absolute: Maybe<number>

    total: number
}

export type OrderQueryAddress = {
    __typename?: "OrderAddress"

    id: string

    firstName: Maybe<string>

    lastName: Maybe<string>

    line1: Maybe<string>

    line2: Maybe<string>

    type: Maybe<string>

    state: Maybe<string>

    city: Maybe<string>

    zip: Maybe<string>

    note: Maybe<string>

    phoneNumber: Maybe<string>

    email: Maybe<string>
}

export type OrderQueryTransactions = {
    __typename?: "Transaction"

    id: Maybe<string>

    state: Maybe<string>

    transactionType: Maybe<string>

    paymentType: Maybe<string>

    accountingType: Maybe<string>

    amount: Maybe<number>

    ccLast4: Maybe<string>

    ccType: Maybe<string>

    ccIssuer: Maybe<string>

    surchargeAmount: Maybe<number>

    cashDiscountAmount: Maybe<number>
}

export type OrderQueryDeliveries = {
    __typename?: "OrderDelivery"

    id: string

    state: Maybe<string>

    externalService: Maybe<string>

    externalServiceId: Maybe<string>

    fee: Maybe<number>

    tip: Maybe<number>

    quotedPickupTime: Maybe<string>

    quotedDeliveryTime: Maybe<string>

    estimatedPickupTime: Maybe<string>

    estimatedDeliveryTime: Maybe<string>

    actualPickupTime: Maybe<string>

    actualDeliveryTime: Maybe<string>

    deliveryTrackingUrl: Maybe<string>
}

export type OrderQuery2Variables = {
    orderId?: Maybe<string>
    assignmentId?: Maybe<string>
}

export type OrderQuery2Query = {
    __typename?: "Query"

    order2: Maybe<OrderQuery2Order2>
}

export type OrderQuery2Order2 = {
    __typename?: "Order2"

    id: string

    number: string

    note: Maybe<string>

    state: OrderState

    placedAt: string

    scheduledFor: Maybe<string>

    paymentMethod: Maybe<OrderPaymentMethod>

    fulfillmentType: Maybe<OrderFulfillmentType>

    paymentState: string

    assignmentName: Maybe<string>

    totals: OrderQuery2Totals

    payments: OrderQuery2Payments[]

    refunds: OrderQuery2Refunds[]

    rewards: OrderQuery2Rewards[]

    items: OrderQuery2Items[]
}

export type OrderQuery2Totals = {
    __typename?: "OrderTotals"

    subtotal: Maybe<number>

    netCollected: Maybe<number>

    total: Maybe<number>
}

export type OrderQuery2Payments = {
    __typename?: "OrderPayment"

    id: string

    timestamp: string

    type: OrderPaymentType

    state: OrderPaymentState

    transactionNumber: Maybe<string>

    amount: Maybe<number>

    tip: Maybe<number>

    priceComponents: OrderQuery2PriceComponents[]

    itemIds: string[]

    customerId: Maybe<string>

    cashReceived: Maybe<number>

    cardDetails: Maybe<OrderQuery2CardDetails>
}

export type OrderQuery2PriceComponents = {
    __typename?: "OrderPriceComponent"

    type: OrderPriceComponentType

    amount: number
}

export type OrderQuery2CardDetails = {
    __typename?: "PaymentCardDetail"

    ccName: Maybe<string>

    ccIssuer: Maybe<string>

    ccLast4: Maybe<string>
}

export type OrderQuery2Refunds = {
    __typename?: "OrderRefund"

    id: string

    paymentId: Maybe<string>

    itemIds: string[]
}

export type OrderQuery2Rewards = {
    __typename?: "OrderReward"

    id: string

    type: Maybe<string>

    amount: number
}

export type OrderQuery2Items = {
    __typename?: "OrderItem2"

    id: string

    quantity: Maybe<number>

    productId: Maybe<string>

    parentCategoryId: Maybe<string>

    unit: Maybe<ProductUnitType>

    cateringType: Maybe<ProductCateringType>

    unitQuantity: Maybe<number>

    name: string

    basePrice: Maybe<number>

    note: Maybe<string>

    totalPrice: Maybe<number>

    pricings: OrderQuery2Pricings[]

    modifierGroups: OrderQuery2ModifierGroups[]

    modifiers: OrderQuery2Modifiers[]

    taxes: OrderQuery2Taxes[]
}

export type OrderQuery2Pricings = {
    __typename?: "OrderItemPricing2"

    id: string

    pricingId: Maybe<string>

    name: Maybe<string>

    percentage: Maybe<number>

    absolute: Maybe<number>

    total: Maybe<number>
}

export type OrderQuery2ModifierGroups = {
    __typename?: "OrderItemModifierGroup2"

    id: string

    name: string

    type: ModifierGroupType

    price: Maybe<number>

    parentModifierId: Maybe<string>

    categoryGroupId: Maybe<string>

    min: Maybe<number>

    max: Maybe<number>

    free: Maybe<number>

    isExclusion: Maybe<boolean>
}

export type OrderQuery2Modifiers = {
    __typename?: "OrderItemModifier2"

    id: string

    groupId: Maybe<string>

    productId: Maybe<string>

    name: string

    quantity: Maybe<number>

    totalPrice: Maybe<number>

    basePrice: Maybe<number>

    supplement: Maybe<number>
}

export type OrderQuery2Taxes = {
    __typename?: "OrderItemTax2"

    id: string

    taxId: string

    name: Maybe<string>

    percentage: Maybe<number>

    absolute: Maybe<number>

    isEmbedded: boolean

    total: Maybe<number>
}

export type ValidateDeliveryAddressQueryVariables = {
    data: ValidateDeliveryAddressInput
}

export type ValidateDeliveryAddressQueryQuery = {
    __typename?: "Query"

    validateDeliveryAddress: Maybe<ValidateDeliveryAddressQueryValidateDeliveryAddress>
}

export type ValidateDeliveryAddressQueryValidateDeliveryAddress = {
    __typename?: "ValidateDeliveryAddressOutput"

    success: boolean

    errors: Maybe<ValidateDeliveryAddressQueryErrors[]>
}

export type ValidateDeliveryAddressQueryErrors = {
    __typename?: "ValidateDeliveryAddressError"

    field: string

    error: string
}

export type CalculateDeliveryFeeQueryVariables = {
    input: CalculateDeliveryFeeInput
}

export type CalculateDeliveryFeeQueryQuery = {
    __typename?: "Query"

    calculateDeliveryFee: Maybe<CalculateDeliveryFeeQueryCalculateDeliveryFee>
}

export type CalculateDeliveryFeeQueryCalculateDeliveryFee = {
    __typename?: "CalculateDeliveryFeeOutput"

    error: Maybe<CalculateDeliveryFeeError>

    fee: Maybe<number>
}

export type TranslateSlugsQueryVariables = {
    accountSlug?: Maybe<string>
    locationSlug?: Maybe<string>
}

export type TranslateSlugsQueryQuery = {
    __typename?: "Query"

    translateSlugs: Maybe<TranslateSlugsQueryTranslateSlugs>
}

export type TranslateSlugsQueryTranslateSlugs = {
    __typename?: "SlugInfo"

    accountId: Maybe<string>

    locationId: Maybe<string>

    terminalId: Maybe<string>
}

export type CreateOrderMutation2Variables = {
    order: OrderInput2
}

export type CreateOrderMutation2Mutation = {
    __typename?: "Mutation"

    createOrder2: Maybe<CreateOrderMutation2CreateOrder2>
}

export type CreateOrderMutation2CreateOrder2 = {
    __typename?: "CreateOrderResponse"

    order: Maybe<CreateOrderMutation2Order>

    order2: Maybe<CreateOrderMutation2Order2>
}

export type CreateOrderMutation2Order = {
    __typename?: "OrderOld2"

    id: Maybe<string>

    number: Maybe<string>

    customerId: Maybe<string>
}

export type CreateOrderMutation2Order2 = {
    __typename?: "Order2"

    id: string

    number: string

    note: Maybe<string>

    state: OrderState

    placedAt: string

    scheduledFor: Maybe<string>

    paymentMethod: Maybe<OrderPaymentMethod>

    fulfillmentType: Maybe<OrderFulfillmentType>

    paymentState: string

    assignmentName: Maybe<string>

    totals: CreateOrderMutation2Totals

    payments: CreateOrderMutation2Payments[]

    refunds: CreateOrderMutation2Refunds[]

    rewards: CreateOrderMutation2Rewards[]

    items: CreateOrderMutation2Items[]
}

export type CreateOrderMutation2Totals = {
    __typename?: "OrderTotals"

    subtotal: Maybe<number>

    netCollected: Maybe<number>

    total: Maybe<number>
}

export type CreateOrderMutation2Payments = {
    __typename?: "OrderPayment"

    id: string

    timestamp: string

    type: OrderPaymentType

    state: OrderPaymentState

    transactionNumber: Maybe<string>

    amount: Maybe<number>

    tip: Maybe<number>

    priceComponents: CreateOrderMutation2PriceComponents[]

    itemIds: string[]

    customerId: Maybe<string>

    cashReceived: Maybe<number>

    cardDetails: Maybe<CreateOrderMutation2CardDetails>
}

export type CreateOrderMutation2PriceComponents = {
    __typename?: "OrderPriceComponent"

    type: OrderPriceComponentType

    amount: number
}

export type CreateOrderMutation2CardDetails = {
    __typename?: "PaymentCardDetail"

    ccName: Maybe<string>

    ccIssuer: Maybe<string>

    ccLast4: Maybe<string>
}

export type CreateOrderMutation2Refunds = {
    __typename?: "OrderRefund"

    id: string

    paymentId: Maybe<string>

    itemIds: string[]
}

export type CreateOrderMutation2Rewards = {
    __typename?: "OrderReward"

    id: string

    type: Maybe<string>

    amount: number
}

export type CreateOrderMutation2Items = {
    __typename?: "OrderItem2"

    id: string

    quantity: Maybe<number>

    productId: Maybe<string>

    parentCategoryId: Maybe<string>

    unit: Maybe<ProductUnitType>

    unitQuantity: Maybe<number>

    cateringType: Maybe<ProductCateringType>

    name: string

    basePrice: Maybe<number>

    note: Maybe<string>

    totalPrice: Maybe<number>

    pricings: CreateOrderMutation2Pricings[]

    modifierGroups: CreateOrderMutation2ModifierGroups[]

    modifiers: CreateOrderMutation2Modifiers[]

    taxes: CreateOrderMutation2Taxes[]
}

export type CreateOrderMutation2Pricings = {
    __typename?: "OrderItemPricing2"

    id: string

    pricingId: Maybe<string>

    name: Maybe<string>

    percentage: Maybe<number>

    absolute: Maybe<number>

    total: Maybe<number>
}

export type CreateOrderMutation2ModifierGroups = {
    __typename?: "OrderItemModifierGroup2"

    id: string

    name: string

    type: ModifierGroupType

    price: Maybe<number>

    parentModifierId: Maybe<string>

    categoryGroupId: Maybe<string>

    min: Maybe<number>

    max: Maybe<number>

    free: Maybe<number>

    isExclusion: Maybe<boolean>
}

export type CreateOrderMutation2Modifiers = {
    __typename?: "OrderItemModifier2"

    id: string

    groupId: Maybe<string>

    productId: Maybe<string>

    name: string

    quantity: Maybe<number>

    totalPrice: Maybe<number>

    basePrice: Maybe<number>

    supplement: Maybe<number>
}

export type CreateOrderMutation2Taxes = {
    __typename?: "OrderItemTax2"

    id: string

    taxId: string

    name: Maybe<string>

    percentage: Maybe<number>

    absolute: Maybe<number>

    isEmbedded: boolean

    total: Maybe<number>
}

export type StartPaymentMutationVariables = {
    paymentInfo?: Maybe<PaymentInput>
}

export type StartPaymentMutationMutation = {
    __typename?: "Mutation"

    startPayment: Maybe<StartPaymentMutationStartPayment>
}

export type StartPaymentMutationStartPayment = {
    __typename?: "PaymentInfo"

    transactionId: Maybe<string>

    paymentRequestId: Maybe<string>

    paymentGateway: Maybe<PaymentGateway>

    message: Maybe<string>

    loyaltyPointsAccrued: Maybe<number>
}

export type UpdateMibUserMutationVariables = {
    mibUserInput?: Maybe<MibUserInput>
}

export type UpdateMibUserMutationMutation = {
    __typename?: "Mutation"

    updateMIBUser: Maybe<UpdateMibUserMutationUpdateMibUser>
}

export type UpdateMibUserMutationUpdateMibUser = {
    __typename?: "MIBUser"

    id: Maybe<string>

    name: Maybe<string>

    email: Maybe<string>

    phone: Maybe<string>

    cognitoId: Maybe<string>

    facebookId: Maybe<string>

    googleId: Maybe<string>

    addresses: Maybe<(Maybe<UpdateMibUserMutationAddresses>)[]>

    loyaltyInfo: Maybe<(Maybe<UpdateMibUserMutationLoyaltyInfo>)[]>

    paymentCards: Maybe<(Maybe<UpdateMibUserMutationPaymentCards>)[]>

    activeSpecialPricings: Maybe<(Maybe<UpdateMibUserMutationActiveSpecialPricings>)[]>
}

export type UpdateMibUserMutationAddresses = {
    __typename?: "MIBUserAddress"

    id: string

    line1: Maybe<string>

    line2: Maybe<string>

    state: Maybe<string>

    city: Maybe<string>

    zip: Maybe<string>

    note: Maybe<string>

    lastUsedTimestamp: string

    sortIndex: number
}

export type UpdateMibUserMutationLoyaltyInfo = {
    __typename?: "MIBUserLoyaltyInfo"

    loyaltyProgramId: string

    rewardsBalance: number

    redemptionMinimum: number

    spendUntilNextReward: number
}

export type UpdateMibUserMutationPaymentCards = {
    __typename?: "MIBUserPaymentCard"

    id: string

    token: string

    name: Maybe<string>

    last4: Maybe<string>

    lastUsedTimestamp: string

    sortIndex: number
}

export type UpdateMibUserMutationActiveSpecialPricings = {
    __typename?: "MIBUserActiveSpecialPricing"

    id: string

    absolute: Maybe<number>

    name: string

    percentage: Maybe<number>
}

export type CreateMibUserAddressVariables = {
    mibUserAddress: CreateMibUserAddressInput
}

export type CreateMibUserAddressMutation = {
    __typename?: "Mutation"

    createMIBUserAddress: Maybe<CreateMibUserAddressCreateMibUserAddress>
}

export type CreateMibUserAddressCreateMibUserAddress = {
    __typename?: "MIBUserAddress"

    id: string

    line1: Maybe<string>

    line2: Maybe<string>

    state: Maybe<string>

    city: Maybe<string>

    zip: Maybe<string>

    note: Maybe<string>

    lastUsedTimestamp: string

    sortIndex: number
}

export type UpdateMibUserAddressVariables = {
    mibUserAddress: UpdateMibUserAddressInput
}

export type UpdateMibUserAddressMutation = {
    __typename?: "Mutation"

    updateMIBUserAddress: Maybe<UpdateMibUserAddressUpdateMibUserAddress>
}

export type UpdateMibUserAddressUpdateMibUserAddress = {
    __typename?: "MIBUserAddress"

    id: string

    line1: Maybe<string>

    line2: Maybe<string>

    state: Maybe<string>

    city: Maybe<string>

    zip: Maybe<string>

    note: Maybe<string>

    lastUsedTimestamp: string
}

export type DeleteMibUserAddressVariables = {
    id: string
}

export type DeleteMibUserAddressMutation = {
    __typename?: "Mutation"

    deleteMIBUserAddress: Maybe<DeleteMibUserAddressDeleteMibUserAddress>
}

export type DeleteMibUserAddressDeleteMibUserAddress = {
    __typename?: "MIBUserAddress"

    id: string
}

export type CreateMibUserPaymentCardVariables = {
    mibUserPaymentCard: CreateMibUserPaymentCardInput
}

export type CreateMibUserPaymentCardMutation = {
    __typename?: "Mutation"

    createMIBUserPaymentCard: Maybe<CreateMibUserPaymentCardCreateMibUserPaymentCard>
}

export type CreateMibUserPaymentCardCreateMibUserPaymentCard = {
    __typename?: "MIBUserPaymentCard"

    id: string

    token: string

    name: Maybe<string>

    last4: Maybe<string>

    lastUsedTimestamp: string

    sortIndex: number
}

export type DeleteMibUserPaymentCardVariables = {
    id: string
}

export type DeleteMibUserPaymentCardMutation = {
    __typename?: "Mutation"

    deleteMIBUserPaymentCard: Maybe<DeleteMibUserPaymentCardDeleteMibUserPaymentCard>
}

export type DeleteMibUserPaymentCardDeleteMibUserPaymentCard = {
    __typename?: "MIBUserPaymentCard"

    id: string
}

export type ChangePaymentTypeVariables = {
    changePaymentTypeInput?: Maybe<ChangePaymentTypeInput>
}

export type ChangePaymentTypeMutation = {
    __typename?: "Mutation"

    changePaymentType: Maybe<ChangePaymentTypeChangePaymentType>
}

export type ChangePaymentTypeChangePaymentType = {
    __typename?: "Response"

    error: Maybe<string>
}

export type AttentionRequestedVariables = {
    input: AttentionRequestedInput
}

export type AttentionRequestedMutation = {
    __typename?: "Mutation"

    attentionRequested: Maybe<AttentionRequestedAttentionRequested>
}

export type AttentionRequestedAttentionRequested = {
    __typename?: "Response"

    error: Maybe<string>
}

import gql from "graphql-tag"
import * as React from "react"
import * as ReactApollo from "react-apollo"

// ====================================================
// Components
// ====================================================

export const CategoriesQueryDocument = gql`
    query CategoriesQuery {
        productsCategories {
            id
            name
            availability {
                timeDataRaw {
                    id
                    name
                    timeSpans {
                        start
                        duration
                        isExclusion
                    }
                }
                timeData {
                    isToday
                    label
                    hours {
                        from
                        to
                    }
                }
            }
            products {
                id
                productId
                name
                price
                description
                isNoteEnabled
                minQuantity
                maxQuantity
                cateringType
                unit
                containsAlcohol
                images {
                    path
                }
                modifierGroups {
                    categoryGroupId
                    name
                    price
                    min
                    max
                    free
                    type
                    sortIndex
                    isExclusion
                    displayType
                    groupPrice
                    options {
                        categoryGroupItemId
                        categoryGroupItemDetailId
                        productId
                        name
                        price
                        supplement
                        sortIndex
                        isPreset
                        isMultipleAllowed
                        nestedGroup {
                            categoryGroupId
                            name
                            price
                            min
                            max
                            free
                            type
                            sortIndex
                            isExclusion
                            displayType
                            groupPrice
                            options {
                                categoryGroupItemId
                                categoryGroupItemDetailId
                                productId
                                name
                                price
                                supplement
                                sortIndex
                                isPreset
                                isMultipleAllowed
                                availability {
                                    inventory {
                                        quantity
                                        threshold
                                    }
                                }
                            }
                        }
                        availability {
                            inventory {
                                quantity
                                threshold
                            }
                        }
                    }
                }
                taxes {
                    taxId
                    name
                    absolute
                    percentage
                    isEmbedded
                }
                pricings {
                    id
                    name
                    absolute
                    percentage
                }
                availability {
                    inventory {
                        quantity
                        threshold
                    }
                }
            }
        }
    }
`
export class CategoriesQueryComponent extends React.Component<
    Partial<ReactApollo.QueryProps<CategoriesQueryQuery, CategoriesQueryVariables>>
> {
    render() {
        return (
            <ReactApollo.Query<CategoriesQueryQuery, CategoriesQueryVariables>
                query={CategoriesQueryDocument}
                {...(this as any)["props"] as any}
            />
        )
    }
}
export type CategoriesQueryProps<TChildProps = any> = Partial<
    ReactApollo.DataProps<CategoriesQueryQuery, CategoriesQueryVariables>
> &
    TChildProps
export function CategoriesQueryHOC<TProps, TChildProps = any>(
    operationOptions:
        | ReactApollo.OperationOption<
              TProps,
              CategoriesQueryQuery,
              CategoriesQueryVariables,
              CategoriesQueryProps<TChildProps>
          >
        | undefined
) {
    return ReactApollo.graphql<
        TProps,
        CategoriesQueryQuery,
        CategoriesQueryVariables,
        CategoriesQueryProps<TChildProps>
    >(CategoriesQueryDocument, operationOptions)
}
export const CategoriesQuery2Document = gql`
    query CategoriesQuery2 {
        productsCategories2 {
            id
            productCategories {
                id
                name
                availability {
                    timeDataRaw {
                        id
                        name
                        timeSpans {
                            start
                            duration
                            isExclusion
                        }
                    }
                    timeData {
                        isToday
                        label
                        hours {
                            from
                            to
                        }
                    }
                }
                products {
                    id
                    productId
                    name
                    price
                    description
                    isNoteEnabled
                    minQuantity
                    maxQuantity
                    cateringType
                    unit
                    containsAlcohol
                    images {
                        path
                    }
                    modifierGroups {
                        categoryGroupUniqueId
                    }
                    taxes {
                        taxId
                        name
                        absolute
                        percentage
                        isEmbedded
                    }
                    pricings {
                        id
                        name
                        absolute
                        percentage
                    }
                    availability {
                        inventory {
                            quantity
                            threshold
                        }
                    }
                }
            }
            modifierGroups {
                categoryGroupId
                categoryGroupUniqueId
                name
                price
                min
                max
                free
                type
                sortIndex
                isExclusion
                displayType
                groupPrice
                options {
                    categoryGroupItemId
                    categoryGroupItemDetailId
                    productId
                    name
                    price
                    supplement
                    sortIndex
                    isPreset
                    isMultipleAllowed
                    nestedGroup {
                        categoryGroupId
                        name
                        price
                        min
                        max
                        free
                        type
                        sortIndex
                        isExclusion
                        displayType
                        groupPrice
                        options {
                            categoryGroupItemId
                            categoryGroupItemDetailId
                            productId
                            name
                            price
                            supplement
                            sortIndex
                            isPreset
                            isMultipleAllowed
                            availability {
                                inventory {
                                    quantity
                                    threshold
                                }
                            }
                        }
                    }
                    availability {
                        inventory {
                            quantity
                            threshold
                        }
                    }
                }
            }
        }
    }
`
export class CategoriesQuery2Component extends React.Component<
    Partial<ReactApollo.QueryProps<CategoriesQuery2Query, CategoriesQuery2Variables>>
> {
    render() {
        return (
            <ReactApollo.Query<CategoriesQuery2Query, CategoriesQuery2Variables>
                query={CategoriesQuery2Document}
                {...(this as any)["props"] as any}
            />
        )
    }
}
export type CategoriesQuery2Props<TChildProps = any> = Partial<
    ReactApollo.DataProps<CategoriesQuery2Query, CategoriesQuery2Variables>
> &
    TChildProps
export function CategoriesQuery2HOC<TProps, TChildProps = any>(
    operationOptions:
        | ReactApollo.OperationOption<
              TProps,
              CategoriesQuery2Query,
              CategoriesQuery2Variables,
              CategoriesQuery2Props<TChildProps>
          >
        | undefined
) {
    return ReactApollo.graphql<
        TProps,
        CategoriesQuery2Query,
        CategoriesQuery2Variables,
        CategoriesQuery2Props<TChildProps>
    >(CategoriesQuery2Document, operationOptions)
}
export const CheckProductsAvailabilityQueryDocument = gql`
    query CheckProductsAvailabilityQuery {
        productsCategories {
            id
            name
            availability {
                timeDataRaw {
                    id
                    name
                    timeSpans {
                        start
                        duration
                        isExclusion
                    }
                }
                timeData {
                    isToday
                    label
                    hours {
                        from
                        to
                    }
                }
            }
            products {
                id
                productId
                name
                price
                modifierGroups {
                    categoryGroupId
                    name
                    price
                    type
                    sortIndex
                    options {
                        categoryGroupItemId
                        categoryGroupItemDetailId
                        productId
                        name
                        price
                        sortIndex
                        availability {
                            inventory {
                                quantity
                                threshold
                            }
                        }
                    }
                }
                availability {
                    inventory {
                        quantity
                        threshold
                    }
                }
            }
        }
    }
`
export class CheckProductsAvailabilityQueryComponent extends React.Component<
    Partial<ReactApollo.QueryProps<CheckProductsAvailabilityQueryQuery, CheckProductsAvailabilityQueryVariables>>
> {
    render() {
        return (
            <ReactApollo.Query<CheckProductsAvailabilityQueryQuery, CheckProductsAvailabilityQueryVariables>
                query={CheckProductsAvailabilityQueryDocument}
                {...(this as any)["props"] as any}
            />
        )
    }
}
export type CheckProductsAvailabilityQueryProps<TChildProps = any> = Partial<
    ReactApollo.DataProps<CheckProductsAvailabilityQueryQuery, CheckProductsAvailabilityQueryVariables>
> &
    TChildProps
export function CheckProductsAvailabilityQueryHOC<TProps, TChildProps = any>(
    operationOptions:
        | ReactApollo.OperationOption<
              TProps,
              CheckProductsAvailabilityQueryQuery,
              CheckProductsAvailabilityQueryVariables,
              CheckProductsAvailabilityQueryProps<TChildProps>
          >
        | undefined
) {
    return ReactApollo.graphql<
        TProps,
        CheckProductsAvailabilityQueryQuery,
        CheckProductsAvailabilityQueryVariables,
        CheckProductsAvailabilityQueryProps<TChildProps>
    >(CheckProductsAvailabilityQueryDocument, operationOptions)
}
export const MerchantInfoQueryDocument = gql`
    query MerchantInfoQuery {
        merchantInfo {
            name
            redirectUrl
            selectorUrl
            mibLocations {
                id
                url
                relativeUrl
                name
                type
                line1
                line2
                zip
                city
                state
                phone_number
                email
                google_place_id
                address_longitude
                address_latitude
                webpage_url
                slug
                timezone
                hasOpenTableOrdering
                hooTimeSpans
                currency
                settings {
                    isBasicButterPromoCodeEnabled
                    useSandboxGateway
                    desktopBackgroundImageUrl
                    primaryColor
                    mainMenuIcon
                    logoUrl
                    minOrderValueForDelivery
                    minOrderValueForPickUp
                    lastTimeForDelivery
                    lastTimeForPickUp
                    pickupEnabled
                    deliveryEnabled
                    deliveryFee
                    deliveryFeeConfig {
                        freeDelivery
                        distanceFeeEnabled
                        distanceFeeValues {
                            distance
                            fee
                        }
                    }
                    deliveryHooTimeSpans
                    pickupHooTimeSpans
                    isAcceptingTipsForDelivery
                    isAcceptingTipsForPickUp
                    isAcceptingCardForDelivery
                    isAcceptingCardForPickUp
                    isAcceptingCashForDelivery
                    isAcceptingCashForPickUp
                    maxDistanceForDelivery
                    estimatedDeliveryTime
                    estimatedPickUpTime
                    acceptFutureOrdersForDelivery
                    acceptFutureOrdersForPickUp
                    futureOrdersDaysForDelivery
                    futureOrdersDaysForPickUp
                    twitterLink
                    facebookLink
                    instagramLink
                    ePurchaseEnabled
                    dineInEnabled
                    doNotCollectEmails
                    cardSurcharge {
                        percentage
                        applyLimit
                    }
                    cashDiscount {
                        percentage
                        absolute
                    }
                    cardSurchargeText
                    cashDiscountText
                    icons {
                        sizes
                        src
                        type
                    }
                    doordashDelivery
                    tippingMethod
                    tippingMethodPercentages
                    tippingPreselectedOptionIndex
                    acceptOnlyFutureOrdersForDelivery
                    acceptOnlyFutureOrdersForPickup
                    deliveryAreaRestrictionType
                    deliveryAllowedAreas {
                        id
                        fee
                        minOrderAmount
                        coords {
                            lat
                            lng
                        }
                    }
                    deliveryAllowedZipCodes
                    doNotMarkAsClosedIfClosed
                    futureOrderingLeadTimeMinutesDelivery
                    futureOrderingLeadTimeActiveDelivery
                    futureOrderingLeadTimeMinutesPickup
                    futureOrderingLeadTimeActivePickup
                    isPickupCurbsideOptionEnabled
                    isPickupCurbsideGuidanceEnabled
                    isDeliveryContactFreeOptionEnabled
                    bannerMessage
                    layoutTemplate
                    isPayingWithEgcEnabled
                    isEcoFriendlyOptionEnabled
                    isEcoFriendlyOptionDefaultChecked
                    isDisabledConfig {
                        forPickup
                        forDelivery
                        until
                    }
                    multipleMerchantsMode
                    futureOrderingDateOnly
                    shouldDisplayDesktopBusinessInfoBox
                    paymentGateway
                    tsysDeviceId
                    applePayEnabled
                    hasNewTableOrdering
                }
            }
            hasMultipleLocations
            images {
                id
                url
                type
            }
        }
    }
`
export class MerchantInfoQueryComponent extends React.Component<
    Partial<ReactApollo.QueryProps<MerchantInfoQueryQuery, MerchantInfoQueryVariables>>
> {
    render() {
        return (
            <ReactApollo.Query<MerchantInfoQueryQuery, MerchantInfoQueryVariables>
                query={MerchantInfoQueryDocument}
                {...(this as any)["props"] as any}
            />
        )
    }
}
export type MerchantInfoQueryProps<TChildProps = any> = Partial<
    ReactApollo.DataProps<MerchantInfoQueryQuery, MerchantInfoQueryVariables>
> &
    TChildProps
export function MerchantInfoQueryHOC<TProps, TChildProps = any>(
    operationOptions:
        | ReactApollo.OperationOption<
              TProps,
              MerchantInfoQueryQuery,
              MerchantInfoQueryVariables,
              MerchantInfoQueryProps<TChildProps>
          >
        | undefined
) {
    return ReactApollo.graphql<
        TProps,
        MerchantInfoQueryQuery,
        MerchantInfoQueryVariables,
        MerchantInfoQueryProps<TChildProps>
    >(MerchantInfoQueryDocument, operationOptions)
}
export const PaymentAuthTokenQueryDocument = gql`
    query PaymentAuthTokenQuery($input: GetPaymentAuthTokenInput) {
        getPaymentAuthToken(input: $input) {
            token
        }
    }
`
export class PaymentAuthTokenQueryComponent extends React.Component<
    Partial<ReactApollo.QueryProps<PaymentAuthTokenQueryQuery, PaymentAuthTokenQueryVariables>>
> {
    render() {
        return (
            <ReactApollo.Query<PaymentAuthTokenQueryQuery, PaymentAuthTokenQueryVariables>
                query={PaymentAuthTokenQueryDocument}
                {...(this as any)["props"] as any}
            />
        )
    }
}
export type PaymentAuthTokenQueryProps<TChildProps = any> = Partial<
    ReactApollo.DataProps<PaymentAuthTokenQueryQuery, PaymentAuthTokenQueryVariables>
> &
    TChildProps
export function PaymentAuthTokenQueryHOC<TProps, TChildProps = any>(
    operationOptions:
        | ReactApollo.OperationOption<
              TProps,
              PaymentAuthTokenQueryQuery,
              PaymentAuthTokenQueryVariables,
              PaymentAuthTokenQueryProps<TChildProps>
          >
        | undefined
) {
    return ReactApollo.graphql<
        TProps,
        PaymentAuthTokenQueryQuery,
        PaymentAuthTokenQueryVariables,
        PaymentAuthTokenQueryProps<TChildProps>
    >(PaymentAuthTokenQueryDocument, operationOptions)
}
export const PaymentStatusQueryDocument = gql`
    query PaymentStatusQuery($transactionId: String!, $paymentRequestId: String, $paymentGateway: PaymentGateway) {
        paymentStatus(
            transactionId: $transactionId
            paymentRequestId: $paymentRequestId
            paymentGateway: $paymentGateway
        ) {
            state
            rewards {
                type
                amount
            }
        }
    }
`
export class PaymentStatusQueryComponent extends React.Component<
    Partial<ReactApollo.QueryProps<PaymentStatusQueryQuery, PaymentStatusQueryVariables>>
> {
    render() {
        return (
            <ReactApollo.Query<PaymentStatusQueryQuery, PaymentStatusQueryVariables>
                query={PaymentStatusQueryDocument}
                {...(this as any)["props"] as any}
            />
        )
    }
}
export type PaymentStatusQueryProps<TChildProps = any> = Partial<
    ReactApollo.DataProps<PaymentStatusQueryQuery, PaymentStatusQueryVariables>
> &
    TChildProps
export function PaymentStatusQueryHOC<TProps, TChildProps = any>(
    operationOptions:
        | ReactApollo.OperationOption<
              TProps,
              PaymentStatusQueryQuery,
              PaymentStatusQueryVariables,
              PaymentStatusQueryProps<TChildProps>
          >
        | undefined
) {
    return ReactApollo.graphql<
        TProps,
        PaymentStatusQueryQuery,
        PaymentStatusQueryVariables,
        PaymentStatusQueryProps<TChildProps>
    >(PaymentStatusQueryDocument, operationOptions)
}
export const MibUserQueryDocument = gql`
    query MibUserQuery {
        mibUser {
            id
            name
            email
            phone
            cognitoId
            facebookId
            googleId
            addresses {
                id
                line1
                line2
                state
                city
                zip
                note
                lastUsedTimestamp
                sortIndex
            }
            loyaltyInfo {
                loyaltyProgramId
                rewardsBalance
                redemptionMinimum
                spendUntilNextReward
            }
            paymentCards {
                id
                token
                name
                last4
                lastUsedTimestamp
                sortIndex
            }
            activeSpecialPricings {
                id
                absolute
                name
                percentage
            }
        }
    }
`
export class MibUserQueryComponent extends React.Component<
    Partial<ReactApollo.QueryProps<MibUserQueryQuery, MibUserQueryVariables>>
> {
    render() {
        return (
            <ReactApollo.Query<MibUserQueryQuery, MibUserQueryVariables>
                query={MibUserQueryDocument}
                {...(this as any)["props"] as any}
            />
        )
    }
}
export type MibUserQueryProps<TChildProps = any> = Partial<
    ReactApollo.DataProps<MibUserQueryQuery, MibUserQueryVariables>
> &
    TChildProps
export function MibUserQueryHOC<TProps, TChildProps = any>(
    operationOptions:
        | ReactApollo.OperationOption<TProps, MibUserQueryQuery, MibUserQueryVariables, MibUserQueryProps<TChildProps>>
        | undefined
) {
    return ReactApollo.graphql<TProps, MibUserQueryQuery, MibUserQueryVariables, MibUserQueryProps<TChildProps>>(
        MibUserQueryDocument,
        operationOptions
    )
}
export const MibUserOrdersQueryDocument = gql`
    query MibUserOrdersQuery {
        mibUser {
            id
            name
            email
            orders2 {
                id
                number
                state
                paymentMethod
                paymentState
                placedAt
                scheduledFor
                fulfillmentType
                note
                total
                items {
                    id
                    quantity
                    name
                }
            }
        }
    }
`
export class MibUserOrdersQueryComponent extends React.Component<
    Partial<ReactApollo.QueryProps<MibUserOrdersQueryQuery, MibUserOrdersQueryVariables>>
> {
    render() {
        return (
            <ReactApollo.Query<MibUserOrdersQueryQuery, MibUserOrdersQueryVariables>
                query={MibUserOrdersQueryDocument}
                {...(this as any)["props"] as any}
            />
        )
    }
}
export type MibUserOrdersQueryProps<TChildProps = any> = Partial<
    ReactApollo.DataProps<MibUserOrdersQueryQuery, MibUserOrdersQueryVariables>
> &
    TChildProps
export function MibUserOrdersQueryHOC<TProps, TChildProps = any>(
    operationOptions:
        | ReactApollo.OperationOption<
              TProps,
              MibUserOrdersQueryQuery,
              MibUserOrdersQueryVariables,
              MibUserOrdersQueryProps<TChildProps>
          >
        | undefined
) {
    return ReactApollo.graphql<
        TProps,
        MibUserOrdersQueryQuery,
        MibUserOrdersQueryVariables,
        MibUserOrdersQueryProps<TChildProps>
    >(MibUserOrdersQueryDocument, operationOptions)
}
export const PromoCodeValidationQueryDocument = gql`
    query PromoCodeValidationQuery($code: String!) {
        promoCodeValidation(code: $code) {
            id
            name
            absolute
            percentage
            isEGiftCard
            eGiftCardRemaining
            conditions {
                minOrderTotal
                maxOrderTotal
                from
                until
            }
        }
    }
`
export class PromoCodeValidationQueryComponent extends React.Component<
    Partial<ReactApollo.QueryProps<PromoCodeValidationQueryQuery, PromoCodeValidationQueryVariables>>
> {
    render() {
        return (
            <ReactApollo.Query<PromoCodeValidationQueryQuery, PromoCodeValidationQueryVariables>
                query={PromoCodeValidationQueryDocument}
                {...(this as any)["props"] as any}
            />
        )
    }
}
export type PromoCodeValidationQueryProps<TChildProps = any> = Partial<
    ReactApollo.DataProps<PromoCodeValidationQueryQuery, PromoCodeValidationQueryVariables>
> &
    TChildProps
export function PromoCodeValidationQueryHOC<TProps, TChildProps = any>(
    operationOptions:
        | ReactApollo.OperationOption<
              TProps,
              PromoCodeValidationQueryQuery,
              PromoCodeValidationQueryVariables,
              PromoCodeValidationQueryProps<TChildProps>
          >
        | undefined
) {
    return ReactApollo.graphql<
        TProps,
        PromoCodeValidationQueryQuery,
        PromoCodeValidationQueryVariables,
        PromoCodeValidationQueryProps<TChildProps>
    >(PromoCodeValidationQueryDocument, operationOptions)
}
export const OrderQueryDocument = gql`
    query OrderQuery($orderId: String) {
        order(orderId: $orderId) {
            id
            number
            note
            state
            createdTimestamp
            scheduledForDateTime
            assignment
            customerId
            customerName
            customerPhone
            customerEmail
            paymentState
            expectedPaymentType
            items {
                id
                quantity
                productId
                price
                name
                total
                unitPrice
                unitQuantity
                unit
                note
                originTimestamp
                pricings {
                    id
                    name
                }
                option {
                    id
                    productId
                    price
                    name
                    nestedModifiers {
                        id
                        productId
                        name
                        price
                        total
                        quantity
                        free
                        supplement
                        min
                        max
                        items {
                            id
                            productId
                            name
                            total
                            price
                            quantity
                            free
                            supplement
                            isExclusion
                        }
                        isExclusion
                    }
                }
                modifiers {
                    id
                    productId
                    name
                    price
                    total
                    quantity
                    free
                    supplement
                    min
                    max
                    items {
                        id
                        productId
                        name
                        total
                        price
                        quantity
                        free
                        supplement
                        isExclusion
                        nestedModifiers {
                            id
                            productId
                            name
                            price
                            total
                            quantity
                            free
                            supplement
                            min
                            max
                            items {
                                id
                                productId
                                name
                                total
                                price
                                quantity
                                free
                                supplement
                                isExclusion
                            }
                            isExclusion
                        }
                    }
                    isExclusion
                }
            }
            specialPricings {
                id
                name
                percentage
                absolute
                total
            }
            address {
                id
                firstName
                lastName
                line1
                line2
                type
                state
                city
                zip
                note
                phoneNumber
                email
            }
            subtotal
            taxesTotal
            total
            transactions {
                id
                state
                transactionType
                paymentType
                accountingType
                amount
                ccLast4
                ccType
                ccIssuer
                surchargeAmount
                cashDiscountAmount
            }
            loyaltyPointsAccrued
            surchargeTotal
            cashDiscountTotal
            deliveries {
                id
                state
                externalService
                externalServiceId
                fee
                tip
                quotedPickupTime
                quotedDeliveryTime
                estimatedPickupTime
                estimatedDeliveryTime
                actualPickupTime
                actualDeliveryTime
                deliveryTrackingUrl
            }
        }
    }
`
export class OrderQueryComponent extends React.Component<
    Partial<ReactApollo.QueryProps<OrderQueryQuery, OrderQueryVariables>>
> {
    render() {
        return (
            <ReactApollo.Query<OrderQueryQuery, OrderQueryVariables>
                query={OrderQueryDocument}
                {...(this as any)["props"] as any}
            />
        )
    }
}
export type OrderQueryProps<TChildProps = any> = Partial<ReactApollo.DataProps<OrderQueryQuery, OrderQueryVariables>> &
    TChildProps
export function OrderQueryHOC<TProps, TChildProps = any>(
    operationOptions:
        | ReactApollo.OperationOption<TProps, OrderQueryQuery, OrderQueryVariables, OrderQueryProps<TChildProps>>
        | undefined
) {
    return ReactApollo.graphql<TProps, OrderQueryQuery, OrderQueryVariables, OrderQueryProps<TChildProps>>(
        OrderQueryDocument,
        operationOptions
    )
}
export const OrderQuery2Document = gql`
    query OrderQuery2($orderId: String, $assignmentId: String) {
        order2(orderId: $orderId, assignmentId: $assignmentId) {
            id
            number
            note
            state
            placedAt
            scheduledFor
            paymentMethod
            fulfillmentType
            paymentState
            assignmentName
            totals {
                subtotal
                netCollected
                total
            }
            payments {
                id
                timestamp
                type
                state
                transactionNumber
                amount
                tip
                priceComponents {
                    type
                    amount
                }
                itemIds
                customerId
                cashReceived
                cardDetails {
                    ccName
                    ccIssuer
                    ccLast4
                }
            }
            refunds {
                id
                paymentId
                itemIds
            }
            rewards {
                id
                type
                amount
            }
            items {
                id
                quantity
                productId
                parentCategoryId
                unit
                cateringType
                unitQuantity
                name
                basePrice
                note
                totalPrice
                pricings {
                    id
                    pricingId
                    name
                    percentage
                    absolute
                    total
                }
                modifierGroups {
                    id
                    name
                    type
                    price
                    parentModifierId
                    categoryGroupId
                    min
                    max
                    free
                    isExclusion
                }
                modifiers {
                    id
                    groupId
                    productId
                    name
                    quantity
                    totalPrice
                    basePrice
                    supplement
                }
                taxes {
                    id
                    taxId
                    name
                    percentage
                    absolute
                    isEmbedded
                    total
                }
            }
        }
    }
`
export class OrderQuery2Component extends React.Component<
    Partial<ReactApollo.QueryProps<OrderQuery2Query, OrderQuery2Variables>>
> {
    render() {
        return (
            <ReactApollo.Query<OrderQuery2Query, OrderQuery2Variables>
                query={OrderQuery2Document}
                {...(this as any)["props"] as any}
            />
        )
    }
}
export type OrderQuery2Props<TChildProps = any> = Partial<
    ReactApollo.DataProps<OrderQuery2Query, OrderQuery2Variables>
> &
    TChildProps
export function OrderQuery2HOC<TProps, TChildProps = any>(
    operationOptions:
        | ReactApollo.OperationOption<TProps, OrderQuery2Query, OrderQuery2Variables, OrderQuery2Props<TChildProps>>
        | undefined
) {
    return ReactApollo.graphql<TProps, OrderQuery2Query, OrderQuery2Variables, OrderQuery2Props<TChildProps>>(
        OrderQuery2Document,
        operationOptions
    )
}
export const ValidateDeliveryAddressQueryDocument = gql`
    query ValidateDeliveryAddressQuery($data: ValidateDeliveryAddressInput!) {
        validateDeliveryAddress(data: $data) {
            success
            errors {
                field
                error
            }
        }
    }
`
export class ValidateDeliveryAddressQueryComponent extends React.Component<
    Partial<ReactApollo.QueryProps<ValidateDeliveryAddressQueryQuery, ValidateDeliveryAddressQueryVariables>>
> {
    render() {
        return (
            <ReactApollo.Query<ValidateDeliveryAddressQueryQuery, ValidateDeliveryAddressQueryVariables>
                query={ValidateDeliveryAddressQueryDocument}
                {...(this as any)["props"] as any}
            />
        )
    }
}
export type ValidateDeliveryAddressQueryProps<TChildProps = any> = Partial<
    ReactApollo.DataProps<ValidateDeliveryAddressQueryQuery, ValidateDeliveryAddressQueryVariables>
> &
    TChildProps
export function ValidateDeliveryAddressQueryHOC<TProps, TChildProps = any>(
    operationOptions:
        | ReactApollo.OperationOption<
              TProps,
              ValidateDeliveryAddressQueryQuery,
              ValidateDeliveryAddressQueryVariables,
              ValidateDeliveryAddressQueryProps<TChildProps>
          >
        | undefined
) {
    return ReactApollo.graphql<
        TProps,
        ValidateDeliveryAddressQueryQuery,
        ValidateDeliveryAddressQueryVariables,
        ValidateDeliveryAddressQueryProps<TChildProps>
    >(ValidateDeliveryAddressQueryDocument, operationOptions)
}
export const CalculateDeliveryFeeQueryDocument = gql`
    query CalculateDeliveryFeeQuery($input: CalculateDeliveryFeeInput!) {
        calculateDeliveryFee(input: $input) {
            error
            fee
        }
    }
`
export class CalculateDeliveryFeeQueryComponent extends React.Component<
    Partial<ReactApollo.QueryProps<CalculateDeliveryFeeQueryQuery, CalculateDeliveryFeeQueryVariables>>
> {
    render() {
        return (
            <ReactApollo.Query<CalculateDeliveryFeeQueryQuery, CalculateDeliveryFeeQueryVariables>
                query={CalculateDeliveryFeeQueryDocument}
                {...(this as any)["props"] as any}
            />
        )
    }
}
export type CalculateDeliveryFeeQueryProps<TChildProps = any> = Partial<
    ReactApollo.DataProps<CalculateDeliveryFeeQueryQuery, CalculateDeliveryFeeQueryVariables>
> &
    TChildProps
export function CalculateDeliveryFeeQueryHOC<TProps, TChildProps = any>(
    operationOptions:
        | ReactApollo.OperationOption<
              TProps,
              CalculateDeliveryFeeQueryQuery,
              CalculateDeliveryFeeQueryVariables,
              CalculateDeliveryFeeQueryProps<TChildProps>
          >
        | undefined
) {
    return ReactApollo.graphql<
        TProps,
        CalculateDeliveryFeeQueryQuery,
        CalculateDeliveryFeeQueryVariables,
        CalculateDeliveryFeeQueryProps<TChildProps>
    >(CalculateDeliveryFeeQueryDocument, operationOptions)
}
export const TranslateSlugsQueryDocument = gql`
    query TranslateSlugsQuery($accountSlug: String, $locationSlug: String) {
        translateSlugs(accountSlug: $accountSlug, locationSlug: $locationSlug) {
            accountId
            locationId
            terminalId
        }
    }
`
export class TranslateSlugsQueryComponent extends React.Component<
    Partial<ReactApollo.QueryProps<TranslateSlugsQueryQuery, TranslateSlugsQueryVariables>>
> {
    render() {
        return (
            <ReactApollo.Query<TranslateSlugsQueryQuery, TranslateSlugsQueryVariables>
                query={TranslateSlugsQueryDocument}
                {...(this as any)["props"] as any}
            />
        )
    }
}
export type TranslateSlugsQueryProps<TChildProps = any> = Partial<
    ReactApollo.DataProps<TranslateSlugsQueryQuery, TranslateSlugsQueryVariables>
> &
    TChildProps
export function TranslateSlugsQueryHOC<TProps, TChildProps = any>(
    operationOptions:
        | ReactApollo.OperationOption<
              TProps,
              TranslateSlugsQueryQuery,
              TranslateSlugsQueryVariables,
              TranslateSlugsQueryProps<TChildProps>
          >
        | undefined
) {
    return ReactApollo.graphql<
        TProps,
        TranslateSlugsQueryQuery,
        TranslateSlugsQueryVariables,
        TranslateSlugsQueryProps<TChildProps>
    >(TranslateSlugsQueryDocument, operationOptions)
}
export const CreateOrderMutation2Document = gql`
    mutation CreateOrderMutation2($order: OrderInput2!) {
        createOrder2(order: $order) {
            order {
                id
                number
                customerId
            }
            order2 {
                id
                number
                note
                state
                placedAt
                scheduledFor
                paymentMethod
                fulfillmentType
                paymentState
                assignmentName
                totals {
                    subtotal
                    netCollected
                    total
                }
                payments {
                    id
                    timestamp
                    type
                    state
                    transactionNumber
                    amount
                    tip
                    priceComponents {
                        type
                        amount
                    }
                    itemIds
                    customerId
                    cashReceived
                    cardDetails {
                        ccName
                        ccIssuer
                        ccLast4
                    }
                }
                refunds {
                    id
                    paymentId
                    itemIds
                }
                rewards {
                    id
                    type
                    amount
                }
                items {
                    id
                    quantity
                    productId
                    parentCategoryId
                    unit
                    unitQuantity
                    cateringType
                    name
                    basePrice
                    note
                    totalPrice
                    pricings {
                        id
                        pricingId
                        name
                        percentage
                        absolute
                        total
                    }
                    modifierGroups {
                        id
                        name
                        type
                        price
                        parentModifierId
                        categoryGroupId
                        min
                        max
                        free
                        isExclusion
                    }
                    modifiers {
                        id
                        groupId
                        productId
                        name
                        quantity
                        totalPrice
                        basePrice
                        supplement
                    }
                    taxes {
                        id
                        taxId
                        name
                        percentage
                        absolute
                        isEmbedded
                        total
                    }
                }
            }
        }
    }
`
export class CreateOrderMutation2Component extends React.Component<
    Partial<ReactApollo.MutationProps<CreateOrderMutation2Mutation, CreateOrderMutation2Variables>>
> {
    render() {
        return (
            <ReactApollo.Mutation<CreateOrderMutation2Mutation, CreateOrderMutation2Variables>
                mutation={CreateOrderMutation2Document}
                {...(this as any)["props"] as any}
            />
        )
    }
}
export type CreateOrderMutation2Props<TChildProps = any> = Partial<
    ReactApollo.MutateProps<CreateOrderMutation2Mutation, CreateOrderMutation2Variables>
> &
    TChildProps
export type CreateOrderMutation2MutationFn = ReactApollo.MutationFn<
    CreateOrderMutation2Mutation,
    CreateOrderMutation2Variables
>
export function CreateOrderMutation2HOC<TProps, TChildProps = any>(
    operationOptions:
        | ReactApollo.OperationOption<
              TProps,
              CreateOrderMutation2Mutation,
              CreateOrderMutation2Variables,
              CreateOrderMutation2Props<TChildProps>
          >
        | undefined
) {
    return ReactApollo.graphql<
        TProps,
        CreateOrderMutation2Mutation,
        CreateOrderMutation2Variables,
        CreateOrderMutation2Props<TChildProps>
    >(CreateOrderMutation2Document, operationOptions)
}
export const StartPaymentMutationDocument = gql`
    mutation StartPaymentMutation($paymentInfo: PaymentInput) {
        startPayment(paymentInfo: $paymentInfo) {
            transactionId
            paymentRequestId
            paymentGateway
            message
            loyaltyPointsAccrued
        }
    }
`
export class StartPaymentMutationComponent extends React.Component<
    Partial<ReactApollo.MutationProps<StartPaymentMutationMutation, StartPaymentMutationVariables>>
> {
    render() {
        return (
            <ReactApollo.Mutation<StartPaymentMutationMutation, StartPaymentMutationVariables>
                mutation={StartPaymentMutationDocument}
                {...(this as any)["props"] as any}
            />
        )
    }
}
export type StartPaymentMutationProps<TChildProps = any> = Partial<
    ReactApollo.MutateProps<StartPaymentMutationMutation, StartPaymentMutationVariables>
> &
    TChildProps
export type StartPaymentMutationMutationFn = ReactApollo.MutationFn<
    StartPaymentMutationMutation,
    StartPaymentMutationVariables
>
export function StartPaymentMutationHOC<TProps, TChildProps = any>(
    operationOptions:
        | ReactApollo.OperationOption<
              TProps,
              StartPaymentMutationMutation,
              StartPaymentMutationVariables,
              StartPaymentMutationProps<TChildProps>
          >
        | undefined
) {
    return ReactApollo.graphql<
        TProps,
        StartPaymentMutationMutation,
        StartPaymentMutationVariables,
        StartPaymentMutationProps<TChildProps>
    >(StartPaymentMutationDocument, operationOptions)
}
export const UpdateMibUserMutationDocument = gql`
    mutation UpdateMIBUserMutation($mibUserInput: MIBUserInput) {
        updateMIBUser(mibUserInput: $mibUserInput) {
            id
            name
            email
            phone
            cognitoId
            facebookId
            googleId
            addresses {
                id
                line1
                line2
                state
                city
                zip
                note
                lastUsedTimestamp
                sortIndex
            }
            loyaltyInfo {
                loyaltyProgramId
                rewardsBalance
                redemptionMinimum
                spendUntilNextReward
            }
            paymentCards {
                id
                token
                name
                last4
                lastUsedTimestamp
                sortIndex
            }
            activeSpecialPricings {
                id
                absolute
                name
                percentage
            }
        }
    }
`
export class UpdateMibUserMutationComponent extends React.Component<
    Partial<ReactApollo.MutationProps<UpdateMibUserMutationMutation, UpdateMibUserMutationVariables>>
> {
    render() {
        return (
            <ReactApollo.Mutation<UpdateMibUserMutationMutation, UpdateMibUserMutationVariables>
                mutation={UpdateMibUserMutationDocument}
                {...(this as any)["props"] as any}
            />
        )
    }
}
export type UpdateMibUserMutationProps<TChildProps = any> = Partial<
    ReactApollo.MutateProps<UpdateMibUserMutationMutation, UpdateMibUserMutationVariables>
> &
    TChildProps
export type UpdateMibUserMutationMutationFn = ReactApollo.MutationFn<
    UpdateMibUserMutationMutation,
    UpdateMibUserMutationVariables
>
export function UpdateMibUserMutationHOC<TProps, TChildProps = any>(
    operationOptions:
        | ReactApollo.OperationOption<
              TProps,
              UpdateMibUserMutationMutation,
              UpdateMibUserMutationVariables,
              UpdateMibUserMutationProps<TChildProps>
          >
        | undefined
) {
    return ReactApollo.graphql<
        TProps,
        UpdateMibUserMutationMutation,
        UpdateMibUserMutationVariables,
        UpdateMibUserMutationProps<TChildProps>
    >(UpdateMibUserMutationDocument, operationOptions)
}
export const CreateMibUserAddressDocument = gql`
    mutation createMIBUserAddress($mibUserAddress: CreateMIBUserAddressInput!) {
        createMIBUserAddress(mibUserAddress: $mibUserAddress) {
            id
            line1
            line2
            state
            city
            zip
            note
            lastUsedTimestamp
            sortIndex
        }
    }
`
export class CreateMibUserAddressComponent extends React.Component<
    Partial<ReactApollo.MutationProps<CreateMibUserAddressMutation, CreateMibUserAddressVariables>>
> {
    render() {
        return (
            <ReactApollo.Mutation<CreateMibUserAddressMutation, CreateMibUserAddressVariables>
                mutation={CreateMibUserAddressDocument}
                {...(this as any)["props"] as any}
            />
        )
    }
}
export type CreateMibUserAddressProps<TChildProps = any> = Partial<
    ReactApollo.MutateProps<CreateMibUserAddressMutation, CreateMibUserAddressVariables>
> &
    TChildProps
export type CreateMibUserAddressMutationFn = ReactApollo.MutationFn<
    CreateMibUserAddressMutation,
    CreateMibUserAddressVariables
>
export function CreateMibUserAddressHOC<TProps, TChildProps = any>(
    operationOptions:
        | ReactApollo.OperationOption<
              TProps,
              CreateMibUserAddressMutation,
              CreateMibUserAddressVariables,
              CreateMibUserAddressProps<TChildProps>
          >
        | undefined
) {
    return ReactApollo.graphql<
        TProps,
        CreateMibUserAddressMutation,
        CreateMibUserAddressVariables,
        CreateMibUserAddressProps<TChildProps>
    >(CreateMibUserAddressDocument, operationOptions)
}
export const UpdateMibUserAddressDocument = gql`
    mutation updateMIBUserAddress($mibUserAddress: UpdateMIBUserAddressInput!) {
        updateMIBUserAddress(mibUserAddress: $mibUserAddress) {
            id
            line1
            line2
            state
            city
            zip
            note
            lastUsedTimestamp
        }
    }
`
export class UpdateMibUserAddressComponent extends React.Component<
    Partial<ReactApollo.MutationProps<UpdateMibUserAddressMutation, UpdateMibUserAddressVariables>>
> {
    render() {
        return (
            <ReactApollo.Mutation<UpdateMibUserAddressMutation, UpdateMibUserAddressVariables>
                mutation={UpdateMibUserAddressDocument}
                {...(this as any)["props"] as any}
            />
        )
    }
}
export type UpdateMibUserAddressProps<TChildProps = any> = Partial<
    ReactApollo.MutateProps<UpdateMibUserAddressMutation, UpdateMibUserAddressVariables>
> &
    TChildProps
export type UpdateMibUserAddressMutationFn = ReactApollo.MutationFn<
    UpdateMibUserAddressMutation,
    UpdateMibUserAddressVariables
>
export function UpdateMibUserAddressHOC<TProps, TChildProps = any>(
    operationOptions:
        | ReactApollo.OperationOption<
              TProps,
              UpdateMibUserAddressMutation,
              UpdateMibUserAddressVariables,
              UpdateMibUserAddressProps<TChildProps>
          >
        | undefined
) {
    return ReactApollo.graphql<
        TProps,
        UpdateMibUserAddressMutation,
        UpdateMibUserAddressVariables,
        UpdateMibUserAddressProps<TChildProps>
    >(UpdateMibUserAddressDocument, operationOptions)
}
export const DeleteMibUserAddressDocument = gql`
    mutation deleteMIBUserAddress($id: String!) {
        deleteMIBUserAddress(id: $id) {
            id
        }
    }
`
export class DeleteMibUserAddressComponent extends React.Component<
    Partial<ReactApollo.MutationProps<DeleteMibUserAddressMutation, DeleteMibUserAddressVariables>>
> {
    render() {
        return (
            <ReactApollo.Mutation<DeleteMibUserAddressMutation, DeleteMibUserAddressVariables>
                mutation={DeleteMibUserAddressDocument}
                {...(this as any)["props"] as any}
            />
        )
    }
}
export type DeleteMibUserAddressProps<TChildProps = any> = Partial<
    ReactApollo.MutateProps<DeleteMibUserAddressMutation, DeleteMibUserAddressVariables>
> &
    TChildProps
export type DeleteMibUserAddressMutationFn = ReactApollo.MutationFn<
    DeleteMibUserAddressMutation,
    DeleteMibUserAddressVariables
>
export function DeleteMibUserAddressHOC<TProps, TChildProps = any>(
    operationOptions:
        | ReactApollo.OperationOption<
              TProps,
              DeleteMibUserAddressMutation,
              DeleteMibUserAddressVariables,
              DeleteMibUserAddressProps<TChildProps>
          >
        | undefined
) {
    return ReactApollo.graphql<
        TProps,
        DeleteMibUserAddressMutation,
        DeleteMibUserAddressVariables,
        DeleteMibUserAddressProps<TChildProps>
    >(DeleteMibUserAddressDocument, operationOptions)
}
export const CreateMibUserPaymentCardDocument = gql`
    mutation createMIBUserPaymentCard($mibUserPaymentCard: CreateMIBUserPaymentCardInput!) {
        createMIBUserPaymentCard(mibUserPaymentCard: $mibUserPaymentCard) {
            id
            token
            name
            last4
            lastUsedTimestamp
            sortIndex
        }
    }
`
export class CreateMibUserPaymentCardComponent extends React.Component<
    Partial<ReactApollo.MutationProps<CreateMibUserPaymentCardMutation, CreateMibUserPaymentCardVariables>>
> {
    render() {
        return (
            <ReactApollo.Mutation<CreateMibUserPaymentCardMutation, CreateMibUserPaymentCardVariables>
                mutation={CreateMibUserPaymentCardDocument}
                {...(this as any)["props"] as any}
            />
        )
    }
}
export type CreateMibUserPaymentCardProps<TChildProps = any> = Partial<
    ReactApollo.MutateProps<CreateMibUserPaymentCardMutation, CreateMibUserPaymentCardVariables>
> &
    TChildProps
export type CreateMibUserPaymentCardMutationFn = ReactApollo.MutationFn<
    CreateMibUserPaymentCardMutation,
    CreateMibUserPaymentCardVariables
>
export function CreateMibUserPaymentCardHOC<TProps, TChildProps = any>(
    operationOptions:
        | ReactApollo.OperationOption<
              TProps,
              CreateMibUserPaymentCardMutation,
              CreateMibUserPaymentCardVariables,
              CreateMibUserPaymentCardProps<TChildProps>
          >
        | undefined
) {
    return ReactApollo.graphql<
        TProps,
        CreateMibUserPaymentCardMutation,
        CreateMibUserPaymentCardVariables,
        CreateMibUserPaymentCardProps<TChildProps>
    >(CreateMibUserPaymentCardDocument, operationOptions)
}
export const DeleteMibUserPaymentCardDocument = gql`
    mutation deleteMIBUserPaymentCard($id: String!) {
        deleteMIBUserPaymentCard(id: $id) {
            id
        }
    }
`
export class DeleteMibUserPaymentCardComponent extends React.Component<
    Partial<ReactApollo.MutationProps<DeleteMibUserPaymentCardMutation, DeleteMibUserPaymentCardVariables>>
> {
    render() {
        return (
            <ReactApollo.Mutation<DeleteMibUserPaymentCardMutation, DeleteMibUserPaymentCardVariables>
                mutation={DeleteMibUserPaymentCardDocument}
                {...(this as any)["props"] as any}
            />
        )
    }
}
export type DeleteMibUserPaymentCardProps<TChildProps = any> = Partial<
    ReactApollo.MutateProps<DeleteMibUserPaymentCardMutation, DeleteMibUserPaymentCardVariables>
> &
    TChildProps
export type DeleteMibUserPaymentCardMutationFn = ReactApollo.MutationFn<
    DeleteMibUserPaymentCardMutation,
    DeleteMibUserPaymentCardVariables
>
export function DeleteMibUserPaymentCardHOC<TProps, TChildProps = any>(
    operationOptions:
        | ReactApollo.OperationOption<
              TProps,
              DeleteMibUserPaymentCardMutation,
              DeleteMibUserPaymentCardVariables,
              DeleteMibUserPaymentCardProps<TChildProps>
          >
        | undefined
) {
    return ReactApollo.graphql<
        TProps,
        DeleteMibUserPaymentCardMutation,
        DeleteMibUserPaymentCardVariables,
        DeleteMibUserPaymentCardProps<TChildProps>
    >(DeleteMibUserPaymentCardDocument, operationOptions)
}
export const ChangePaymentTypeDocument = gql`
    mutation changePaymentType($changePaymentTypeInput: ChangePaymentTypeInput) {
        changePaymentType(changePaymentTypeInput: $changePaymentTypeInput) {
            error
        }
    }
`
export class ChangePaymentTypeComponent extends React.Component<
    Partial<ReactApollo.MutationProps<ChangePaymentTypeMutation, ChangePaymentTypeVariables>>
> {
    render() {
        return (
            <ReactApollo.Mutation<ChangePaymentTypeMutation, ChangePaymentTypeVariables>
                mutation={ChangePaymentTypeDocument}
                {...(this as any)["props"] as any}
            />
        )
    }
}
export type ChangePaymentTypeProps<TChildProps = any> = Partial<
    ReactApollo.MutateProps<ChangePaymentTypeMutation, ChangePaymentTypeVariables>
> &
    TChildProps
export type ChangePaymentTypeMutationFn = ReactApollo.MutationFn<ChangePaymentTypeMutation, ChangePaymentTypeVariables>
export function ChangePaymentTypeHOC<TProps, TChildProps = any>(
    operationOptions:
        | ReactApollo.OperationOption<
              TProps,
              ChangePaymentTypeMutation,
              ChangePaymentTypeVariables,
              ChangePaymentTypeProps<TChildProps>
          >
        | undefined
) {
    return ReactApollo.graphql<
        TProps,
        ChangePaymentTypeMutation,
        ChangePaymentTypeVariables,
        ChangePaymentTypeProps<TChildProps>
    >(ChangePaymentTypeDocument, operationOptions)
}
export const AttentionRequestedDocument = gql`
    mutation attentionRequested($input: AttentionRequestedInput!) {
        attentionRequested(input: $input) {
            error
        }
    }
`
export class AttentionRequestedComponent extends React.Component<
    Partial<ReactApollo.MutationProps<AttentionRequestedMutation, AttentionRequestedVariables>>
> {
    render() {
        return (
            <ReactApollo.Mutation<AttentionRequestedMutation, AttentionRequestedVariables>
                mutation={AttentionRequestedDocument}
                {...(this as any)["props"] as any}
            />
        )
    }
}
export type AttentionRequestedProps<TChildProps = any> = Partial<
    ReactApollo.MutateProps<AttentionRequestedMutation, AttentionRequestedVariables>
> &
    TChildProps
export type AttentionRequestedMutationFn = ReactApollo.MutationFn<
    AttentionRequestedMutation,
    AttentionRequestedVariables
>
export function AttentionRequestedHOC<TProps, TChildProps = any>(
    operationOptions:
        | ReactApollo.OperationOption<
              TProps,
              AttentionRequestedMutation,
              AttentionRequestedVariables,
              AttentionRequestedProps<TChildProps>
          >
        | undefined
) {
    return ReactApollo.graphql<
        TProps,
        AttentionRequestedMutation,
        AttentionRequestedVariables,
        AttentionRequestedProps<TChildProps>
    >(AttentionRequestedDocument, operationOptions)
}

// ====================================================
// Types
// ====================================================

export interface Query {
    featureFlags?: Maybe<(Maybe<FeatureFlag>)[]>

    merchantInfo?: Maybe<MerchantInfo>

    productsCategories?: Maybe<(Maybe<ProductCategory>)[]>

    productsCategories2?: Maybe<ProductCategories>

    paymentStatus?: Maybe<TransactionStatus>

    translateSlugs?: Maybe<SlugInfo>

    mibUser?: Maybe<MibUser>

    order?: Maybe<Order>

    order2?: Maybe<Order2>

    promoCodeValidation?: Maybe<PromoCode>

    validateDeliveryAddress?: Maybe<ValidateDeliveryAddressOutput>

    getPaymentAuthToken?: Maybe<GetPaymentAuthTokenResponse>

    getPaymentRedirectUrl?: Maybe<GetPaymentRedirectUrlResponse>

    calculateDeliveryFee?: Maybe<CalculateDeliveryFeeOutput>
}

export interface FeatureFlag {
    key: string

    value: boolean
}

export interface MerchantInfo {
    id: string

    name: string

    slug?: Maybe<string>

    selectorUrl?: Maybe<string>

    hasMultipleLocations?: Maybe<boolean>

    redirectUrl?: Maybe<string>

    mibLocations?: Maybe<MibLocation[]>

    loyaltyPrograms?: Maybe<MerchantLoyaltyProgram[]>

    images?: Maybe<(Maybe<Image>)[]>
}

export interface MibLocation {
    id: string

    name: string

    slug?: Maybe<string>

    url?: Maybe<string>

    relativeUrl?: Maybe<string>

    type?: Maybe<MibLocationType>

    settings: MibLocationSettings

    line1?: Maybe<string>

    line2?: Maybe<string>

    zip?: Maybe<string>

    city?: Maybe<string>

    state?: Maybe<string>

    phone_number?: Maybe<string>

    email?: Maybe<string>

    google_place_id?: Maybe<string>

    address_longitude?: Maybe<number>

    address_latitude?: Maybe<number>

    webpage_url?: Maybe<string>

    timezone?: Maybe<string>

    hooTimeSpans: string[]

    hasOpenTableOrdering: boolean

    currency?: Maybe<Currency>
}

export interface MibLocationSettings {
    logo?: Maybe<string>

    desktopBackgroundImageBase64?: Maybe<string>

    icons: MakeItButterIcon[]

    logoUrl?: Maybe<string>

    primaryColor?: Maybe<string>

    mainMenuIcon: MainMenuIcon

    isAcceptingCardForDelivery: boolean

    isAcceptingCardForPickUp: boolean

    isAcceptingCashForDelivery: boolean

    isAcceptingCashForPickUp: boolean

    isAcceptingTipsForDelivery: boolean

    isAcceptingTipsForPickUp: boolean

    shouldSendEmailToMerchant: boolean

    estimatedDeliveryTime?: Maybe<number>

    estimatedPickUpTime?: Maybe<number>

    lastTimeForDelivery?: Maybe<number>

    lastTimeForPickUp?: Maybe<number>

    deliveryAreaRestrictionType: DeliveryAreaRestriction

    maxDistanceForDelivery?: Maybe<number>

    deliveryAllowedZipCodes?: Maybe<(Maybe<string>)[]>

    deliveryAllowedAreas?: Maybe<DeliveryMapAreaData[]>

    minOrderValueForDelivery?: Maybe<number>

    minOrderValueForPickUp?: Maybe<number>

    deliveryEnabled: boolean

    pickupEnabled: boolean

    deliveryFee?: Maybe<number>

    deliveryFeeConfig?: Maybe<DeliveryFeeConfig>

    doordashDelivery?: Maybe<DoorDashDelivery>

    desktopBackgroundImageUrl?: Maybe<string>

    useSandboxGateway: boolean

    isBasicButterPromoCodeEnabled: boolean

    acceptFutureOrdersForDelivery: boolean

    acceptFutureOrdersForPickUp: boolean

    futureOrdersDaysForDelivery?: Maybe<number>

    futureOrdersDaysForPickUp?: Maybe<number>

    cardSurcharge?: Maybe<CardSurchargeInfo>

    cashDiscount?: Maybe<CashDiscountInfo>

    cardSurchargeText: string

    cashDiscountText: string

    twitterLink?: Maybe<string>

    instagramLink?: Maybe<string>

    facebookLink?: Maybe<string>

    ePurchaseEnabled: boolean

    dineInEnabled: boolean

    doNotCollectEmails: boolean

    tippingMethod: TippingMethodEnum

    tippingMethodPercentages?: Maybe<number[]>

    tippingPreselectedOptionIndex?: Maybe<number>

    acceptOnlyFutureOrdersForDelivery: boolean

    acceptOnlyFutureOrdersForPickup: boolean

    doNotMarkAsClosedIfClosed: boolean

    futureOrderingLeadTimeActiveDelivery: boolean

    futureOrderingLeadTimeActivePickup: boolean

    futureOrderingLeadTimeMinutesDelivery: number

    futureOrderingLeadTimeMinutesPickup: number

    isPickupCurbsideOptionEnabled: boolean

    isPickupCurbsideGuidanceEnabled: boolean

    isDeliveryContactFreeOptionEnabled: boolean

    bannerMessage?: Maybe<string>

    layoutTemplate: MibLayoutTemplateType

    isPayingWithEgcEnabled: boolean

    isEcoFriendlyOptionEnabled: boolean

    isEcoFriendlyOptionDefaultChecked: boolean

    isDisabledConfig?: Maybe<MibIsDisabledConfig>

    multipleMerchantsMode?: Maybe<boolean>

    deliveryHooTimeSpans?: Maybe<string[]>

    pickupHooTimeSpans?: Maybe<string[]>

    futureOrderingDateOnly: boolean

    shouldDisplayDesktopBusinessInfoBox: boolean

    paymentGateway: PaymentGateway

    tsysDeviceId?: Maybe<string>

    applePayEnabled: boolean

    hasNewTableOrdering?: Maybe<boolean>
}

export interface MakeItButterIcon {
    sizes: string

    type: string

    src: string
}

export interface DeliveryMapAreaData {
    id: string

    fee?: Maybe<number>

    minOrderAmount?: Maybe<number>

    coords: DeliveryMapAreaCoords[]
}

export interface DeliveryMapAreaCoords {
    lat: number

    lng: number
}

export interface DeliveryFeeConfig {
    freeDelivery?: Maybe<number>

    distanceFeeEnabled?: Maybe<boolean>

    distanceFeeValues?: Maybe<DistanceFeeItem[]>
}

export interface DistanceFeeItem {
    distance: number

    fee: number
}

export interface CardSurchargeInfo {
    percentage: number

    applyLimit?: Maybe<number>
}

export interface CashDiscountInfo {
    percentage?: Maybe<number>

    absolute?: Maybe<number>
}

export interface MibIsDisabledConfig {
    forDelivery: boolean

    forPickup: boolean

    until?: Maybe<string>
}

export interface MerchantLoyaltyProgram {
    id: string

    rewardsIncentive: number

    redemptionMinimum: number

    startDate: string
}

export interface Image {
    id: string

    url: string

    type?: Maybe<string>

    label?: Maybe<string>

    sortIndex?: Maybe<number>
}

export interface ProductCategory {
    id?: Maybe<string>

    name?: Maybe<string>

    shortName?: Maybe<string>

    description?: Maybe<string>

    products?: Maybe<(Maybe<Product>)[]>

    availability?: Maybe<CategoryAvailabilityData>
}

export interface Product {
    id?: Maybe<string>

    productId?: Maybe<string>

    name?: Maybe<string>

    description?: Maybe<string>

    price?: Maybe<number>

    isNoteEnabled?: Maybe<boolean>

    modifierGroups?: Maybe<(Maybe<ProductModifierGroup>)[]>

    taxes?: Maybe<(Maybe<ProductTax>)[]>

    pricings?: Maybe<(Maybe<ProductPricing>)[]>

    images?: Maybe<(Maybe<ProductImage>)[]>

    availability?: Maybe<ProductAvailabilityData>

    minQuantity?: Maybe<number>

    maxQuantity?: Maybe<number>

    cateringType?: Maybe<ProductCateringType>

    unit?: Maybe<ProductUnitType>

    containsAlcohol?: Maybe<boolean>
}

export interface ProductModifierGroup {
    categoryGroupId?: Maybe<string>

    categoryGroupUniqueId?: Maybe<string>

    name?: Maybe<string>

    price?: Maybe<number>

    min?: Maybe<number>

    max?: Maybe<number>

    free?: Maybe<number>

    type?: Maybe<string>

    sortIndex?: Maybe<number>

    isExclusion?: Maybe<boolean>

    displayType?: Maybe<string>

    groupPrice?: Maybe<number>

    options?: Maybe<(Maybe<ProductModifier>)[]>
}

export interface ProductModifier {
    categoryGroupItemId?: Maybe<string>

    categoryGroupItemDetailId?: Maybe<string>

    productId?: Maybe<string>

    name?: Maybe<string>

    price?: Maybe<number>

    supplement?: Maybe<number>

    sortIndex?: Maybe<number>

    isPreset?: Maybe<boolean>

    isMultipleAllowed?: Maybe<boolean>

    availability?: Maybe<ProductAvailabilityData>

    nestedGroup?: Maybe<ProductModifierGroup>
}

export interface ProductAvailabilityData {
    inventory?: Maybe<InventoryAvailabilityData>
}

export interface InventoryAvailabilityData {
    inventoryLocationId?: Maybe<string>

    quantity?: Maybe<number>

    threshold?: Maybe<number>
}

export interface ProductTax {
    taxId?: Maybe<string>

    name?: Maybe<string>

    absolute?: Maybe<number>

    percentage?: Maybe<number>

    isEmbedded?: Maybe<boolean>
}

export interface ProductPricing {
    id: string

    name: string

    percentage?: Maybe<number>

    absolute?: Maybe<number>
}

export interface ProductImage {
    path: string

    type?: Maybe<string>
}

export interface CategoryAvailabilityData {
    timeDataRaw: TimeEntry

    timeData: AvailabilityDay[]
}

export interface TimeEntry {
    id: string

    name: string

    timeSpans?: Maybe<TimeSpan[]>
}

export interface TimeSpan {
    start: string

    duration: number

    isExclusion: boolean
}

export interface AvailabilityDay {
    isToday: boolean

    label: string

    hours: AvailabilityDayHours[]
}

export interface AvailabilityDayHours {
    from: string

    to: string
}

export interface ProductCategories {
    id?: Maybe<string>

    productCategories?: Maybe<(Maybe<ProductCategory>)[]>

    modifierGroups?: Maybe<(Maybe<ProductModifierGroup>)[]>
}

export interface TransactionStatus {
    transactionId?: Maybe<string>

    state?: Maybe<string>

    rewards?: Maybe<Reward[]>
}

export interface Reward {
    type: string

    amount?: Maybe<number>
}

export interface SlugInfo {
    accountId?: Maybe<string>

    locationId?: Maybe<string>

    terminalId?: Maybe<string>
}

export interface MibUser {
    id?: Maybe<string>

    name?: Maybe<string>

    email?: Maybe<string>

    phone?: Maybe<string>

    cognitoId?: Maybe<string>

    facebookId?: Maybe<string>

    googleId?: Maybe<string>

    orders2: OrderPreview[]

    loyaltyInfo?: Maybe<(Maybe<MibUserLoyaltyInfo>)[]>

    addresses?: Maybe<(Maybe<MibUserAddress>)[]>

    paymentCards?: Maybe<(Maybe<MibUserPaymentCard>)[]>

    activeSpecialPricings?: Maybe<(Maybe<MibUserActiveSpecialPricing>)[]>

    originTimestamp?: Maybe<string>
}

export interface OrderPreview {
    id: string

    number: string

    state: string

    paymentMethod: string

    paymentState: string

    placedAt: string

    scheduledFor?: Maybe<string>

    fulfillmentType?: Maybe<string>

    note?: Maybe<string>

    total: number

    items: OrderItemPreview[]
}

export interface OrderItemPreview {
    id: string

    quantity?: Maybe<number>

    name?: Maybe<string>
}

export interface MibUserLoyaltyInfo {
    loyaltyProgramId: string

    rewardsBalance: number

    redemptionMinimum: number

    spendUntilNextReward: number
}

export interface MibUserAddress {
    id: string

    line1?: Maybe<string>

    line2?: Maybe<string>

    state?: Maybe<string>

    city?: Maybe<string>

    zip?: Maybe<string>

    note?: Maybe<string>

    lastUsedTimestamp: string

    sortIndex: number
}

export interface MibUserPaymentCard {
    id: string

    token: string

    expiration: string

    zip?: Maybe<string>

    name?: Maybe<string>

    last4?: Maybe<string>

    lastUsedTimestamp: string

    sortIndex: number
}

export interface MibUserActiveSpecialPricing {
    id: string

    name: string

    percentage?: Maybe<number>

    absolute?: Maybe<number>
}

export interface Order {
    id: string

    number: string

    note?: Maybe<string>

    state: string

    createdTimestamp: string

    scheduledForDateTime?: Maybe<string>

    expectedPaymentType?: Maybe<string>

    assignmentId?: Maybe<string>

    assignment?: Maybe<string>

    customerId?: Maybe<string>

    customerName?: Maybe<string>

    customerPhone?: Maybe<string>

    customerEmail?: Maybe<string>

    items: OrderItem[]

    specialPricings?: Maybe<OrderSpecialPricing[]>

    address?: Maybe<OrderAddress>

    transactions?: Maybe<Transaction[]>

    subtotal: number

    taxesTotal: number

    total: number

    paymentState: string

    loyaltyPointsAccrued?: Maybe<number>

    surchargeTotal?: Maybe<number>

    cashDiscountTotal?: Maybe<number>

    deliveries?: Maybe<OrderDelivery[]>
}

export interface OrderItem {
    id: string

    quantity?: Maybe<number>

    productId?: Maybe<string>

    price?: Maybe<number>

    name?: Maybe<string>

    total?: Maybe<number>

    unitPrice?: Maybe<number>

    unitQuantity?: Maybe<number>

    unit?: Maybe<string>

    note?: Maybe<string>

    option?: Maybe<OrderItemOption>

    modifiers?: Maybe<OrderItemModifier[]>

    pricings?: Maybe<(Maybe<OrderItemPricing>)[]>

    originTimestamp: string
}

export interface OrderItemOption {
    id: string

    productId: string

    price?: Maybe<number>

    name?: Maybe<string>

    nestedModifiers?: Maybe<OrderItemModifier[]>
}

export interface OrderItemModifier {
    id?: Maybe<string>

    productId?: Maybe<string>

    name?: Maybe<string>

    min?: Maybe<number>

    max?: Maybe<number>

    price?: Maybe<number>

    quantity?: Maybe<number>

    total?: Maybe<number>

    free?: Maybe<number>

    supplement?: Maybe<number>

    items?: Maybe<OrderItemModifier[]>

    isExclusion?: Maybe<boolean>

    nestedModifiers?: Maybe<OrderItemModifier[]>
}

export interface OrderItemPricing {
    id: string

    name?: Maybe<string>
}

export interface OrderSpecialPricing {
    id: string

    name?: Maybe<string>

    percentage?: Maybe<number>

    absolute?: Maybe<number>

    total: number
}

export interface OrderAddress {
    id: string

    firstName?: Maybe<string>

    lastName?: Maybe<string>

    line1?: Maybe<string>

    line2?: Maybe<string>

    type?: Maybe<string>

    state?: Maybe<string>

    city?: Maybe<string>

    zip?: Maybe<string>

    note?: Maybe<string>

    phoneNumber?: Maybe<string>

    email?: Maybe<string>
}

export interface Transaction {
    id?: Maybe<string>

    state?: Maybe<string>

    transactionNumber?: Maybe<string>

    transactionType?: Maybe<string>

    paymentType?: Maybe<string>

    accountingType?: Maybe<string>

    amount?: Maybe<number>

    ccLast4?: Maybe<string>

    ccType?: Maybe<string>

    ccIssuer?: Maybe<string>

    surchargeAmount?: Maybe<number>

    cashDiscountAmount?: Maybe<number>
}

export interface OrderDelivery {
    id: string

    state?: Maybe<string>

    externalService?: Maybe<string>

    externalServiceId?: Maybe<string>

    fee?: Maybe<number>

    tip?: Maybe<number>

    quotedPickupTime?: Maybe<string>

    quotedDeliveryTime?: Maybe<string>

    estimatedPickupTime?: Maybe<string>

    estimatedDeliveryTime?: Maybe<string>

    actualPickupTime?: Maybe<string>

    actualDeliveryTime?: Maybe<string>

    deliveryTrackingUrl?: Maybe<string>
}

export interface Order2 {
    id: string

    number: string

    note?: Maybe<string>

    state: OrderState

    placedAt: string

    scheduledFor?: Maybe<string>

    paymentMethod?: Maybe<OrderPaymentMethod>

    assignmentName?: Maybe<string>

    fulfillmentType?: Maybe<OrderFulfillmentType>

    paymentState: string

    items: OrderItem2[]

    payments: OrderPayment[]

    refunds: OrderRefund[]

    rewards: OrderReward[]

    totals: OrderTotals
}

export interface OrderItem2 {
    id: string

    quantity?: Maybe<number>

    productId?: Maybe<string>

    parentCategoryId?: Maybe<string>

    cateringType?: Maybe<ProductCateringType>

    unit?: Maybe<ProductUnitType>

    unitQuantity?: Maybe<number>

    name: string

    basePrice?: Maybe<number>

    note?: Maybe<string>

    totalPrice?: Maybe<number>

    modifierGroups: OrderItemModifierGroup2[]

    modifiers: OrderItemModifier2[]

    pricings: OrderItemPricing2[]

    taxes: OrderItemTax2[]
}

export interface OrderItemModifierGroup2 {
    id: string

    name: string

    type: ModifierGroupType

    price?: Maybe<number>

    parentModifierId?: Maybe<string>

    categoryGroupId?: Maybe<string>

    min?: Maybe<number>

    max?: Maybe<number>

    free?: Maybe<number>

    isExclusion?: Maybe<boolean>
}

export interface OrderItemModifier2 {
    id: string

    groupId?: Maybe<string>

    productId?: Maybe<string>

    name: string

    quantity?: Maybe<number>

    totalPrice?: Maybe<number>

    basePrice?: Maybe<number>

    supplement?: Maybe<number>
}

export interface OrderItemPricing2 {
    id: string

    pricingId?: Maybe<string>

    name?: Maybe<string>

    percentage?: Maybe<number>

    absolute?: Maybe<number>

    total?: Maybe<number>
}

export interface OrderItemTax2 {
    id: string

    taxId: string

    name?: Maybe<string>

    percentage?: Maybe<number>

    absolute?: Maybe<number>

    isEmbedded: boolean

    total?: Maybe<number>
}

export interface OrderPayment {
    id: string

    timestamp: string

    type: OrderPaymentType

    state: OrderPaymentState

    transactionNumber?: Maybe<string>

    amount?: Maybe<number>

    tip?: Maybe<number>

    priceComponents: OrderPriceComponent[]

    itemIds: string[]

    customerId?: Maybe<string>

    cashReceived?: Maybe<number>

    cardDetails?: Maybe<PaymentCardDetail>
}

export interface OrderPriceComponent {
    type: OrderPriceComponentType

    amount: number
}

export interface PaymentCardDetail {
    ccName?: Maybe<string>

    ccIssuer?: Maybe<string>

    ccLast4?: Maybe<string>
}

export interface OrderRefund {
    id: string

    paymentId?: Maybe<string>

    itemIds: string[]
}

export interface OrderReward {
    id: string

    type?: Maybe<string>

    amount: number
}

export interface OrderTotals {
    subtotal?: Maybe<number>

    netCollected?: Maybe<number>

    total?: Maybe<number>
}

export interface PromoCode {
    id?: Maybe<string>

    name?: Maybe<string>

    absolute?: Maybe<number>

    percentage?: Maybe<number>

    isEGiftCard?: Maybe<boolean>

    eGiftCardRemaining?: Maybe<number>

    conditions?: Maybe<PromoConditions>
}

export interface PromoConditions {
    minOrderTotal?: Maybe<number>

    maxOrderTotal?: Maybe<number>

    from?: Maybe<string>

    until?: Maybe<string>
}

export interface ValidateDeliveryAddressOutput {
    success: boolean

    errors?: Maybe<ValidateDeliveryAddressError[]>
}

export interface ValidateDeliveryAddressError {
    field: string

    error: string
}

export interface GetPaymentAuthTokenResponse {
    token?: Maybe<string>
}

export interface GetPaymentRedirectUrlResponse {
    redirectUrl?: Maybe<string>

    externalOrderId?: Maybe<string>
}

export interface CalculateDeliveryFeeOutput {
    fee?: Maybe<number>

    error?: Maybe<CalculateDeliveryFeeError>
}

export interface Mutation {
    createOrder2?: Maybe<CreateOrderResponse>

    startPayment?: Maybe<PaymentInfo>

    changePaymentType?: Maybe<Response>

    updateMIBUser?: Maybe<MibUser>

    createMIBUserAddress?: Maybe<MibUserAddress>

    updateMIBUserAddress?: Maybe<MibUserAddress>

    deleteMIBUserAddress?: Maybe<MibUserAddress>

    createMIBUserPaymentCard?: Maybe<MibUserPaymentCard>

    deleteMIBUserPaymentCard?: Maybe<MibUserPaymentCard>

    productSiteSignUpForm?: Maybe<Response>

    attentionRequested?: Maybe<Response>
}

export interface CreateOrderResponse {
    order?: Maybe<OrderOld2>

    order2?: Maybe<Order2>
}

export interface OrderOld2 {
    id?: Maybe<string>

    number?: Maybe<string>

    note?: Maybe<string>

    state?: Maybe<string>

    createdTimestamp?: Maybe<string>

    scheduledForDateTime?: Maybe<string>

    assignment?: Maybe<string>

    customerId?: Maybe<string>

    items?: Maybe<OrderItem[]>

    taxes?: Maybe<OrderTax[]>

    specialPricings?: Maybe<OrderSpecialPricing[]>

    address?: Maybe<OrderAddress>

    transactions?: Maybe<Transaction[]>

    transactionId?: Maybe<string>

    paymentGateway?: Maybe<PaymentGateway>

    paymentRequestId?: Maybe<string>

    subtotal?: Maybe<number>

    taxesTotal?: Maybe<number>

    total?: Maybe<number>

    paymentState?: Maybe<string>

    loyaltyPointsAccrued?: Maybe<number>

    loyaltyPointsAccruableOncePaid?: Maybe<number>

    surchargeTotal?: Maybe<number>

    cashDiscountTotal?: Maybe<number>
}

export interface OrderTax {
    id: string

    name: string

    percentage?: Maybe<number>

    absolute?: Maybe<number>

    total: number
}

export interface PaymentInfo {
    transactionId?: Maybe<string>

    paymentGateway?: Maybe<PaymentGateway>

    paymentRequestId?: Maybe<string>

    loyaltyPointsAccrued?: Maybe<number>

    loyaltyPointsAccruableOncePaid?: Maybe<number>

    price?: Maybe<number>

    message?: Maybe<string>
}

export interface Response {
    error?: Maybe<string>
}

export interface CustomerAddressInfo {
    id?: Maybe<string>

    line1?: Maybe<string>

    line2?: Maybe<string>

    type?: Maybe<string>

    state?: Maybe<string>

    city?: Maybe<string>

    zip?: Maybe<string>

    note?: Maybe<string>

    phone_number?: Maybe<string>

    email?: Maybe<string>
}

export interface DateRange {
    start?: Maybe<string>

    end?: Maybe<string>
}

export interface InventoryLowQuantityItem {
    productId: string

    name: string

    type: LowQuantityItemType

    quantity: number
}

export interface MibUserExists {
    exists: boolean
}

export interface PaymentStatus {
    paymentRequestId?: Maybe<string>

    state?: Maybe<string>

    responseCode?: Maybe<string>
}

// ====================================================
// Arguments
// ====================================================

export interface PaymentStatusQueryArgs {
    transactionId: string

    paymentRequestId?: Maybe<string>

    paymentGateway?: Maybe<PaymentGateway>
}
export interface TranslateSlugsQueryArgs {
    accountSlug?: Maybe<string>

    locationSlug?: Maybe<string>
}
export interface OrderQueryArgs {
    orderId?: Maybe<string>

    assignmentId?: Maybe<string>
}
export interface Order2QueryArgs {
    orderId?: Maybe<string>

    assignmentId?: Maybe<string>
}
export interface PromoCodeValidationQueryArgs {
    code: string
}
export interface ValidateDeliveryAddressQueryArgs {
    data: ValidateDeliveryAddressInput
}
export interface GetPaymentAuthTokenQueryArgs {
    input?: Maybe<GetPaymentAuthTokenInput>
}
export interface GetPaymentRedirectUrlQueryArgs {
    input: GetPaymentRedirectUrlInput
}
export interface CalculateDeliveryFeeQueryArgs {
    input: CalculateDeliveryFeeInput
}
export interface LoyaltyInfoMibUserArgs {
    accountId?: Maybe<string>
}
export interface ActiveSpecialPricingsMibUserArgs {
    locationId?: Maybe<string>

    accountId?: Maybe<string>
}
export interface CreateOrder2MutationArgs {
    order: OrderInput2
}
export interface StartPaymentMutationArgs {
    paymentInfo?: Maybe<PaymentInput>
}
export interface ChangePaymentTypeMutationArgs {
    changePaymentTypeInput?: Maybe<ChangePaymentTypeInput>
}
export interface UpdateMibUserMutationArgs {
    mibUserInput?: Maybe<MibUserInput>
}
export interface CreateMibUserAddressMutationArgs {
    mibUserAddress: CreateMibUserAddressInput
}
export interface UpdateMibUserAddressMutationArgs {
    mibUserAddress: UpdateMibUserAddressInput
}
export interface DeleteMibUserAddressMutationArgs {
    id: string
}
export interface CreateMibUserPaymentCardMutationArgs {
    mibUserPaymentCard: CreateMibUserPaymentCardInput
}
export interface DeleteMibUserPaymentCardMutationArgs {
    id: string
}
export interface ProductSiteSignUpFormMutationArgs {
    input: ProductSiteSignUpFormPayload
}
export interface AttentionRequestedMutationArgs {
    input: AttentionRequestedInput
}
